import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { DataObject } from 'src/app/common/models/crosstab.model';
import { parse } from "date-fns";
import {
  customGroupsvalidationRules,
  customCalculationvalidationRules,
} from 'src/app/common/constants/custom-group-validation';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import { SnapshotService } from '../Services/snapshot.service';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { AlertMessageModel } from 'src/app/common/models/common.model';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import {
  BUTTON_HOVER_NAMES,
  COMMON_CONSTANTS,
} from 'src/app/common/constants/common-constants';
@Component({
  selector: 'app-custom-metric-widgetlibrary',
  templateUrl: './custom-metric-widgetlibrary.component.html',
  styleUrls: ['./custom-metric-widgetlibrary.component.css']
})
export class CustomMetricWidgetlibraryComponent {
  @Output() isNumeralEvent = new EventEmitter<boolean>();
  @Output() showLoaderEvent = new EventEmitter<boolean>();
  @Input() handleNumeralPopUPeventdata:any;
  @Input() addnumeraleventdata:any;
  isPreviewExpand: Boolean = false;
  isCustomMetricPercentage: Boolean = true;
  isCustomMeanMetric: Boolean = false;
  disabledCustomGroupOperatorList: string[] = [];
  isThresholdEnabled: Boolean = false;
  buttonCssClassMap: Record<string, string> = {
    '(': 'openParaButton',
    ')': 'closeParaButton',
    NOT: 'notButton',
    AND: 'andButton',
    OR: 'orButton',
    METRIC: 'customGroup',
    NUMERAL: 'numeralButton',
    '+': 'addButton',
    '-': 'subtractButton',
    '*': 'multiplyButton',
    '/': 'divideButton',
  };
  public dataObject: DataObject = {
    Row: [],
    Column: [],
    RowNesting: [],
    ColNesting: [],
    Filter: [],
    CustomGroup: [],
    CustomCalculation: [],
  };
  listCustomCalculationItemsList: any = [];
  listCustomGroupItemsList: {
    customGroupRowOrder?: number;
    Level0: string;
    Level1: string;
    tooltip: string;
    has_nextLevel: boolean;
    sortId: number;
    is_Derived: string;
    is_calc_type: string;
    data_variable_code: string;
    data_response_code: string;
    data_sort_id: string;
    data_is_multi_punch: string;
    data_date: string;
    data_year_code: string;
    is_dimension: boolean;
    is_custmGrpPresent: boolean;
    is_custmCalcPresent: boolean;
    kibanaFilterScript: string;
    customGroupId: string;
    customCalculationId: string;
    dataYearCode: string;
    isSelectAllMetrics: boolean;
    isSelectAllMetricsCount: number;
    is_entrypoint: boolean
  }[] = [];
  customGroupItemIndex: number = -1;
  customGroupRowOrder: number = 1;
  customGroupSelectionsObj: {
    displayString: string;
    oneObject: any;
    operatorValue: string;
    type: string;
    rowOrder?: number;
    variableCode: string;
    responseCode: string;
    headerText: string;
    notFound: boolean;
  }[] = [];
  metricdata: any;
  searchmetric: any;
  metricGroupLength: any;
  metricgroup: any;
  metrics: any = [];
  uniqueMetricsWithTrend: any;
  groupedData1: any;
  groupedData: any;
  isMetricConfigured: any;
  widgets: any;
  showErrorPopUp: any;
  errorheaderTitle: any;
  popUpMessage: any;

  snapshotname: any = "";
  clientName: any = "";
  allmetrics: any = [];
  confirmationType : any
  confirmationMessage : any
  isShowDialog : any
  deleteMetricsData :any

  constructor(private _alertService: AlertMessageService, private _loaderService: LoaderService, public _configCustomService: CustomsnapshotService, private cdRef: ChangeDetectorRef, private _configData: SnapshotService, private clientDetails: SnapshotSharedVariablesService) {
    this._loaderService.showLoader();
    let data1 = {
      client_code: this.clientDetails.clientDetails.client_name,
      study_name: this.clientDetails.clientDetails.selectedStudy,
    };
    this._configCustomService.getCustomSnapshotProperties().subscribe((r: any) => {
      this._configData.getWidgetLibraryMetricList(data1)
        .subscribe((data: any) => {
          this.metricdata = JSON.parse(data.Data);
          this.metricdata = this.metricdata.filter((item: any) => item['Is_snapshot'] === 1);
          //

          this.metricGroupLength = this.metricdata.filter((a: any) => a.WidgetMapping_VariableGroups != "").length;

          if (this.metricGroupLength != 0) {
            this.metricgroup = Array.from(
              new Set(
                this.metricdata.map(
                  (item: any) => item['WidgetMapping_VariableGroups']
                )
              )
            );
          }

          this.metrics = Array.from(
            new Set(
              this.metricdata.map(
                (item: any) => item['WidgetMapping_Variables']
              )
            )
          );
          this.uniqueMetricsWithTrend = Array.from(
            new Map(
              this.metricdata.map((item: any) => [
                `${item.WidgetMapping_Variables}-${item.Trend_Flag}`,
                { WidgetMapping_Variables: item.WidgetMapping_Variables, Trend_Flag: item.Trend_Flag }
              ])
            ).values()
          );
          let brandanalysis: any = {};
          let calculationType: any = {};
          let response_code:any={};
          let variable_code:any={};
          this.metrics.forEach((m: any) => {
            const foundItem = this.metricdata.find((m1: any) => m1['WidgetMapping_Variables'] === m);
            if (foundItem) {
              const isBrandAnalysisValue = foundItem['is_brandanalysis'];
              const isCalculationTypeValue = foundItem['calculation_type'];
              const responseCode=foundItem['response_code'];
              const variableCode=foundItem['data_variable_code'];
              response_code[m]=responseCode;
              variable_code[m]=variableCode;
              brandanalysis[m] = isBrandAnalysisValue;
              calculationType[m] = isCalculationTypeValue;
              // Or store the result in another array or object as needed
            }
          });
          //
          this.metrics = this.metrics.map((m: any) => ({
            option: m,
            isSelected: false,
            selectorder: 0,
            isBrandAnalysis: brandanalysis[m],
            calculationType: calculationType[m],
            response_code:response_code[m],
            variable_code:variable_code[m]
          }));
          this.allmetrics = _.cloneDeep(this.metrics);
          if (this.isCustomMetricPercentage) {
            this.metrics = this.allmetrics.filter((m: any) => m.calculationType === "share");
          }
          if (this.isCustomMeanMetric) {
            this.metrics = this.allmetrics.filter((m: any) => m.calculationType === "mean");
          }
                              this.groupedData1 = this.getGroupedData(this.metricdata);
          this.groupedData1.forEach((item: any) => {
            item.option = item.metricgroup;
            item.Level2 = item.metrics.map((m: any) => ({
              option: m,
              isSelected: false,
              selectorder: 0,
            }));
            item.type = 'checkbox';
            item.isDropdownOpen = false;
          });

          this.groupedData = [{
            option: "METRIC GROUP",
            isDropdownOpen: false,
            type: "radio",
            Level2: this.metricgroup?.map((m: any) => ({
              option: m,
              isSelected: false,
              selectorder: 0
            }))
          },
          {
            option: "METRICS",
            isDropdownOpen: false,
            type: "checkbox",
            Level2: this.metrics
          }
          ]
                              this._configCustomService.metricData = this.groupedData;
          // this._configCustomService.prepareCustomizationList(JSON.parse(r?.Data));
          // this._configCustomService.widgets = JSON.parse(r?.Data)?.ChartPropertiesOptionSelection.map((obj: any) => {
          //   return {
          //     SnapshotType: obj.SnapshotType,
          //     Chart: obj.Chart,
          //     ChartGroup: obj.ChartGroup
          //   };
          // });
          // this._configCustomService.widgets.push({
          //   Chart: "LINE CHART",
          //   ChartGroup: "Line Chart",
          //   SnapshotType: "Single Brand"
          // });
          // this.widgets = this._configCustomService.widgets;
          this.isMetricConfigured = true;
          this._loaderService.hideLoader();
        },
          (error: any) => {
            // Handle error here
            // this.showErrorPopUp=false;
            this.isMetricConfigured = false
            setTimeout(() => {
              this.showErrorPopUp = true;
              this.errorheaderTitle = "Alert";
              this.popUpMessage = "Metrics not Configured for the Study :" + this.clientDetails.clientDetails.selectedStudy;
              this.cdRef.detectChanges();
            }, 0)
          }

        );
    })
  }
  existingData: any = [];
  existing_custom_metric: any = [];
  existing_custom_metric_details: any = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['handleNumeralPopUPeventdata'] && changes['handleNumeralPopUPeventdata'].currentValue !== undefined) {
      this.handleNumeralPopUP(this._configCustomService.handleNumeraleventdata);
    }

    if (changes['addnumeraleventdata'] && changes['addnumeraleventdata'].currentValue !== undefined) {
      if(changes['addnumeraleventdata'].currentValue){
       this.addNumeral(this._configCustomService.addNumeraleventdata);
      }
    }
  }

  ngOnInit() {
    // let event: Event = new Event('');


    this._configData.fromBackButton = true;
    this._configCustomService.fromBackButton = true;
    const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configData.ChartCustomSaveDataObject, fromBack: true };
    this._configCustomService.recievedStatusDataOnBackButtonClick = dataToSend;
    //pass above event to this.bindCustomGroupFlags
    if (this.isCustomMetricPercentage) {
      let event: Event = new CustomEvent('customEvent', {
        detail: {
          displayMainComponent: false,
          isCreateCustomGroup: true,
          isDeleteCustomGroup: false,
          isDuplicateCustomGroup: false,
          isMeanMetric: false,
          isShareCustomGroup: false,
          isShareMetric: true,
          isUpdateCustomGroup: false
        }
      });
      this.bindCustomGroupFlags((event as CustomEvent).detail);
    }
    else {
      let event: Event = new CustomEvent('customEvent', {
        detail: {
          displayMainComponent: false,
          isCreateCustomGroup: false,
          isDeleteCustomGroup: false,
          isDuplicateCustomGroup: false,
          isMeanMetric: true,
          isShareCustomGroup: false,
          isShareMetric: true,
          isUpdateCustomGroup: false
        }
      });
      this.bindCustomCalculationOperatorClick(event, '(');
    }
    this.initialCall();
    // let datatosubmit={
    //                     "client_name":this._configData.clientName,
    //                     "study":this.clientDetails.clientDetails.selectedStudy,
    //                     "created_by": user,
    //                     "created_date": "2024-12-18T10:00:00Z",
    //                     "id": "selection1",
    //                     "isDuplicate": false,
    //                     "isUpdate": true,
    //                     "is_active": true,
    //                     "is_brand_analysis": false,
    //                     "is_shared": false,
    //                     "modified_by": "User2",
    //                     "modified_date": "2024-12-18T12:00:00Z",
    //                     "module_id": 1001,
    //                     "selection_name": "Selection Name 1",
    //                     "selection_object": "{\"criteria\":\"value\"}",
    //                     "selection_query": "{\"query\":\"select * from table\"}",
    //                     "selection_query_answerbase": "AnswerBaseQuery",
    //                     "shared_with": ["Team1", "Team2"],
    //                     "sortid": 1,
    //                     "user_name": user,
    //                     "soft_delete": "0"
    // };


    // this._configCustomService.saveCustomMetricSnapshotWidgetLibrary(datatosubmit).subscribe(
    //   (response: any) => {
    //   }
    // );
  }



  all_existing_custom_metric: any = [];
  initialCall() {
    let data = {
      "clientName": this._configData.clientName,
      "snapshotName": this.clientDetails.clientDetails.selectedStudy,
    }
    this._configCustomService.getCustomMetrics(data).subscribe((r: any) => {
      if (r.Data != "" && r.Data != null) {
        this.existingData = JSON.parse(r?.Data);
        this.existing_custom_metric = [];
        this.existing_custom_metric_details = [];
        this.setCustomMetricList();
                this.checkIfMetricInFomPresent();
        this.cdRef.detectChanges();
      }
    });
  }

  setCustomMetricList() {
    this.existingData= this.existingData.filter((r: any) => r.soft_delete == "0" && r.is_active);
    this.all_existing_custom_metric = this.getUniqueSelectionNames(this.existingData, this._configCustomService.selectedSnapshotType?.name, this._configCustomService.selectedSection, this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "" ? "NA" : this._configCustomService.selectedSubsection);
    if (this.isCustomMetricPercentage) { this.existing_custom_metric = _.cloneDeep(this.all_existing_custom_metric.filter((m: any) => m.selection_type == "CustomGroup")); }
    if (this.isCustomMeanMetric) { this.existing_custom_metric = _.cloneDeep(this.all_existing_custom_metric.filter((m: any) => m.selection_type == "CustomCalculation")); }
    //sort this.existing_custom_metric on creation date in ascending order
    // this.existing_custom_metric = this.existing_custom_metric.sort((a: any, b: any) => {
    //   return new Date(b.created_date).getTime() - new Date(a.created_date).getTime();
    // });
    const dateFormat = "dd/MM/yyyy, HH:mm:ss";
    this.existing_custom_metric.sort((a:any, b:any) => {
      const dateA = parse(a.created_date, dateFormat, new Date()).getTime();
      const dateB = parse(b.created_date, dateFormat, new Date()).getTime();
      return dateA - dateB; // Ascending order
    });
      }

  getUniqueSelectionNames(
    existingData: any[],
    snapshotTypeName: string,
    sectionName: string,
    subsectionName: string
  ) {
    const uniqueSelectionDetails = new Set<string>();

    // Traverse snapshotType to find the matching snapshotType_name
    existingData.forEach((item: any) => {
      if (item.selection_name && item.selection_type) {
        const uniqueKey = `${item.selection_name}|${item.selection_type}`; // Create a unique key combining both fields
        if (!uniqueSelectionDetails.has(uniqueKey)) {
          uniqueSelectionDetails.add(uniqueKey);
          this.existing_custom_metric_details.push(item);
        }
      }
    });

    // Convert back into an array of objects
    return Array.from(uniqueSelectionDetails).map((key) => {
      const [selection_name, selection_type] = key.split('|');
      return {
        name: selection_name,
        selection_type: selection_type,
        isSelected: false,
        created_date: this.existing_custom_metric_details.find((r: any) => r.selection_name == selection_name).created_date
      };
    });
  }


  handleCustomGroupSavePopUp(eventData: { isClose: boolean }): void {
    this.isSaveCustomGroupSelectionClick = eventData.isClose;
  }

  isSaveCustomGroupSelectionClick = false;
  showLoaderPopUp: boolean = false;
  customGroupSelectionName: string = '';
  saveCustomGroupSelection() {
    var validationResult = this.validateCustomGroupSummary();
    var parenthesisCheck = this.ParenthesisCheck();
    // var areAllDropDownsValid = this.validateCustomGroupDropDowns();
    var areAllDropDownsValid = { valid: true }
    if (
      validationResult.isSelectionValid &&
      parenthesisCheck &&
      areAllDropDownsValid.valid
    ) {
      if (this.isUpdateCustomGroup) {
        //to update
        this.CustomGroupSaveSelection({
          isValidationPass: true,
          selectionName: this.selectedCustomGroupName,
          isUpdate: this.isUpdateCustomGroup,
          isDuplicate: this.isDuplicateCustomGroup,
        });
      } else
      {this.isSaveCustomGroupSelectionClick = true;
        // if(this.isDuplicateCustomGroup){
        // this.customGroupSelectionName = this.selectedCustomGroupName;
        // }
      } //to open save popup
    } else {
      if (!validationResult.isSelectionValid) {
        this.errorPopup(
          validationResult.messageForerror ||
          "Percentage Variable doesn't seem to be correct. Kindly check the selection."
        );
      } else if (!parenthesisCheck) {
        {
          this.errorPopup(
            "Percentage Variable doesn't seem to be correct.Kindly check if the Parenthesis are placed in the right place."
          );
        }
      } else {
        this.errorPopup(
          "Percentage Variable doesn't seem to be correct.Kindly check the selection."
        );
      }
    }
  }

  // to save custom mean metrics
  isUpdateCustomCalculation: boolean = false;
  selectedCustomCalculationName: string = '';
  isDuplicateCustomCalculation: boolean = false;
  isSaveCustomCalculationSelectionClick: boolean = false;
  saveCustomCalculationSelection() {
    var validationResult = this.validateCustomCalculationSummary();
    var parenthesisCheck = this.ParenthesisCheck('customCalculation');
    //var areAllDropDownsValid = this.validateCustomCalculationDropDowns();
    if (
      validationResult.isSelectionValid &&
      parenthesisCheck
      //&&
      //areAllDropDownsValid.valid
    ) {
      if (this.isUpdateCustomCalculation) {
        //to update
        this.CustomCalculationSaveSelection({
          isValidationPass: true,
          selectionName: this.selectedCustomCalculationName,
          isUpdate: this.isUpdateCustomCalculation,
          isDuplicate: this.isDuplicateCustomCalculation,
        });
      } else this.isSaveCustomCalculationSelectionClick = true; //to open save popup
    } else {
      if (!validationResult.isSelectionValid) {
        if (validationResult.messageForerror != "") {
          this.errorPopup(validationResult.messageForerror);
        }
        else
          this.errorPopup(
            "Mean Variable doesn't seem to be correct.Kindly check the selection."
          );
      } else if (!parenthesisCheck) {
        {
          this.errorPopup(
            "Mean Variable doesn't seem to be correct.Kindly check if the Parenthesis are placed in the right place."
          );
        }
      } else {
        this.errorPopup(
          "Mean Variable doesn't seem to be correct.Kindly check the selection."
        );
      }
    }
  }



  // onDuplicate(item: any) {
  //   //this.isDuplicateCustomGroup = true;
  //   this.isUpdateCustomGroup = false;
  //   this.selectedCustomGroupName = item.name;


  //   let data = _.cloneDeep(this.existing_custom_metric_details.find((r: any) => r.selection_name == item.name));

  //   if (data) {
  //     let dataObject = JSON.parse(data.selection_object);

  //     //write a code to edit the data.selection_name to selection_name_copy and if selection_name_copy exists then selection_name_copy_1 and so on and if selection_copy is duplicated then it should be selection_copy_copy and so on
  //     let selectionName = item.name;
  //     let selectionNameCopy = selectionName + "_Copy";
  //     let copyIndex = 1;
  //     let isDuplicate = true;
  //     while (isDuplicate) {
  //       let item = this.existing_custom_metric.find((r: any) => r.name == selectionNameCopy);
  //       if (item) {
  //         copyIndex++;
  //         selectionNameCopy = selectionName + "_Copy_" + copyIndex;
  //       } else {
  //         isDuplicate = false;
  //       }
  //     }
  //     data.selection_name = selectionNameCopy;

  //     if (this.isCustomMetricPercentage) {
  //       this.customGroupSelectionsObj = dataObject.listCustomGroupItemsList;
  //       this.listCustomGroupItemsList = dataObject.customGroupSelectionsObj;
  //       this.selectedCustomGroupName = selectionNameCopy;
  //     }
  //     if (this.isCustomMeanMetric) {
  //       this.customCalculationSelectionsObj = dataObject.listCustomCalculationItemsList;
  //       this.listCustomCalculationItemsList = dataObject.customCalculationSelectionsObj;
  //       this.selectedCustomCalculationName = selectionNameCopy;
  //     }


  //     //this.existingData.push(data);
  //     //this.setCustomMetricList();

  //     let item1 = this.existing_custom_metric.find((r: any) => r.name == selectionNameCopy);
  //     this.isEditClicked = true;
  //     //this.onUpdate(item1);

  //     // if( !this.isCustomMeanMetric){
  //     //  this.saveCustomGroupSelection()
  //     // }
  //     // else{this.saveCustomCalculationSelection()}
  //   }

  //   // this.existingData.push(data);


  // }
 isDuplicateClicked=false;
  onDuplicate(item: any){
      let event: {
        displayMainComponent: boolean;
        isCreateCustomGroup: boolean;
        isUpdateCustomGroup: boolean;
        isDeleteCustomGroup: boolean;
        isDuplicateCustomGroup: boolean;
        isShareCustomGroup: boolean;
        selectedCustomGroupName: string;
        selectedCustomGroupName_Bucket: string;
        customGroupId: string;
        isShareMetric: boolean;
        isMeanMetric: boolean;
      } = {
        displayMainComponent: false,
        isUpdateCustomGroup: false,
        isCreateCustomGroup: false,
        isDeleteCustomGroup: false,
        isDuplicateCustomGroup: true,
        isShareCustomGroup: false,
        selectedCustomGroupName: item.name,
        selectedCustomGroupName_Bucket: "userDefined",
        customGroupId: "",
        isShareMetric: false,
        isMeanMetric: true
      };

      let calculationEvent: {
        displayMainComponent: boolean;
        isCreateCustomCalculation: boolean;
        isUpdateCustomCalculation: boolean;
        isDeleteCustomCalculation: boolean;
        isDuplicateCustomCalculation: boolean;
        isShareCustomCalculation: boolean;
        selectedCustomCalculationName: string;
        selectedCustomCalculationName_Bucket: string;
        customCalculationId: string;
        isMeanMetric: boolean;
        isShareMetric: boolean;
        isCreateCustomGroup: boolean;
      } = {
        displayMainComponent: false,
        isCreateCustomCalculation: false,
        isUpdateCustomCalculation: false,
        isDeleteCustomCalculation: false,
        isDuplicateCustomCalculation: true,
        isShareCustomCalculation: false,
        selectedCustomCalculationName: item.name,
        selectedCustomCalculationName_Bucket: "userDefined",
        customCalculationId: "",
        isMeanMetric: true,
        isShareMetric: false,
        isCreateCustomGroup: false
      };

      // if (!this.isDuplicateCustomGroup) {
      //   this.isEditClicked = true;
      // }
      // this.existing_custom_metric.forEach((r: any) => {
      //   if (r.name == item.name) {
      //     r.isSelected = true;
      //   }
      //   else {
      //     r.isSelected = false;
      //   }
      // }
      // );
    this.isEditClicked=true;
    let data = _.cloneDeep(this.existing_custom_metric_details.find((r: any) => r.selection_name == item.name));

    if (data) {
      let dataObject = JSON.parse(data.selection_object);

      //write a code to edit the data.selection_name to selection_name_copy and if selection_name_copy exists then selection_name_copy_1 and so on and if selection_copy is duplicated then it should be selection_copy_copy and so on
      let selectionName = item.name;
      let selectionNameCopy = selectionName + "_Copy";
      let copyIndex = 1;
      let isDuplicate = true;
      while (isDuplicate) {
        let item = this.existing_custom_metric.find((r: any) => r.name == selectionNameCopy);
        if (item) {
          copyIndex++;
          selectionNameCopy = selectionName + "_Copy_" + copyIndex;
        } else {
          isDuplicate = false;
        }
      }
      data.selection_name = selectionNameCopy;
      this.customGroupSelectionName = selectionNameCopy;
       this.existingData.push(data);
       this.setCustomMetricList();
       this.existing_custom_metric.forEach((r: any) => {
        if (r.name == selectionNameCopy) {
          r.isSelected = true;
        }
        else {
          r.isSelected = false;
        }
      });
    }
      this.isDuplicateClicked=true;
      if (this.isCustomMeanMetric) {
        this.bindCustomCalculationFlags(calculationEvent);
      }
      if (this.isCustomMetricPercentage) {
        this.bindCustomGroupFlags(event);
      }
  }

  isDeleteCustomGrouporCalculation: boolean = false;

  DeleteMetric(){
    this.isDuplicateCustomGroup = false;
    this.isUpdateCustomGroup = false;
    this.isDeleteCustomGrouporCalculation=true;
    this.selectedCustomGroupName = this.deleteMetricsData.name;
    this.CustomGroupSaveSelection({
      isValidationPass: true,
      selectionName: this.selectedCustomGroupName,
      isUpdate: this.isUpdateCustomGroup,
      isDuplicate: this.isDuplicateCustomGroup,
    });
    // this.isDeleteCustomGrouporCalculation=false;
    this.setCustomMetricList();
    this.clearCustomGroupSelection();
    this.cdRef.detectChanges();

  }
  onDelete(item: any) {
    this.deleteMetricsData = item;
    // this.isDuplicateCustomGroup = false;
    // this.isUpdateCustomGroup = false;
    // this.isDeleteCustomGrouporCalculation=true;
    // this.selectedCustomGroupName = item.name;
    // this.CustomGroupSaveSelection({
    //   isValidationPass: true,
    //   selectionName: this.selectedCustomGroupName,
    //   isUpdate: this.isUpdateCustomGroup,
    //   isDuplicate: this.isDuplicateCustomGroup,
    // });

    this.confirmationType = "Delete";
    // Prepare the confirmation message
    let message = `Please confirm if the Custom Metric ${item.name} will be deleted.`;
    // Show the confirmation dialog with the prepared message
    this.showConfirmationDialog(message);

  }

  showConfirmationDialog(message: string) {
    // Set the confirmation message for the dialog
    this.confirmationMessage = message;
    // Set the flag to show the confirmation dialog
    this.isShowDialog = true;
  }

  onConfirmation(operation: number) {
    if (operation === 1) {
      // If the action is confirmed, execute the corresponding action based on the confirmation type
      switch (this.confirmationType.toLowerCase()) {
        case "delete":
          this.DeleteMetric();
          // Execute the insertUsers function for submitting users
          break;
        default:
          // Hide the dialog if no specific action is associated with the confirmation type
          this.isShowDialog = false;
          break;
      }
      // Hide the dialog after executing the action
      this.isShowDialog = false;
    } else {
      // User canceled the action, hide the dialog
      this.isShowDialog = false;
    }
  }

  handleCustomCalculationSavePopUp(eventData: { isClose: boolean }): void {
    this.isSaveCustomCalculationSelectionClick = eventData.isClose;
  }




  validateCustomCalculationSummary() {
    var jsonDataList = this.customCalculationSelectionsObj;
    var validationResult = {
      isSelectionValid: true,
      messageForerror: "",
      invalidObject: {},
    };

    var previousSelection = '';
    for (var i in jsonDataList) {
      if (i == "1") {
        if (jsonDataList[i].operatorValue == "NUMERAL") {
          validationResult.isSelectionValid = false;
          validationResult.messageForerror = "A numeral cannot be selected first; the metric should always be selected first."
        }
      }
      if (validationResult.isSelectionValid) {
        var currentSelection = '';

        if (previousSelection == '') {
          if (jsonDataList[i].type == 'metric') {
            previousSelection = 'metric';
          } else {
            previousSelection = jsonDataList[i].operatorValue;
          }
        } else {
          if (jsonDataList[i].type == 'metric') {
            currentSelection = 'metric';
          } else {
            currentSelection = jsonDataList[i].operatorValue;
          }

          for (var j in customCalculationvalidationRules) {
            if (
              previousSelection != null &&
              previousSelection != undefined &&
              previousSelection.toLowerCase() ==
              customCalculationvalidationRules[
                j
              ].latestSelection.toLowerCase()
            ) {
              if (
                customCalculationvalidationRules[j].itemsToBeEnabled.indexOf(
                  currentSelection.toUpperCase()
                ) >= 0 ||
                customCalculationvalidationRules[j].itemsToBeEnabled.indexOf(
                  currentSelection.toLowerCase()
                ) >= 0
              ) {
              } else {
                validationResult.isSelectionValid = false;
                validationResult.invalidObject = jsonDataList[i];
              }
              break;
            }
          }

          previousSelection = currentSelection;
        }
      } else {
        break;
      }
    }

    return validationResult;
  }

  generateCustomGroupHtml() {
    this.customGroupSelectionsObj.forEach((r) => {
      this.customGroupHtml += '<div>' + r.displayString + '</div>';
    });
  }

  generateCustomCalculationHtml() {
    this.customCalculationSelectionsObj.forEach((r) => {
      this.customCalculationHtml += '<div>' + r.displayString + '</div>';
    });
  }

  generateCustomGroupQueryInput(input: any): any {
    let result = '';
    input.forEach((row: any) => {
      if (row.type === 'metric') {
        if (row.isMultipunch) {
          result += '( ';
          row.variableCode
            // .split('|')
            .split('OR')
            .forEach((variableCode: string, index: number) => {
              const responseCodes = row.responseCode.split('|');
              result += variableCode.trim() + ':' + responseCodes[index];
              if (index !== row.variableCode.split('OR').length - 1)
                result += ' OR ';
            });
          result += ' ) ';
        } else {
          const variableCodes =
            row.variableCode.indexOf('OR') > -1
              ? row.variableCode.trim().split('OR')
              : row.variableCode.split('|');
          const responseCodes = row.responseCode.split('|');
          variableCodes.forEach((variableCode: string, index: number) => {
            //dont add OR to the last variable code
            if (
              row.variableCode.indexOf('OR') > -1 &&
              variableCodes.length - 1 != index
            ) {
              result +=
                variableCode.trim() + ':' + responseCodes[index] + ' OR ';
            } else {
              result += variableCode.trim() + ':' + responseCodes[index] + ' ';
            }
          });

          //const lastOrIndex = result.lastIndexOf(' OR ');
          // if (lastOrIndex !== -1) {
          //   result = result.substring(0, lastOrIndex);
          // }
        }
      } else if (row.type === 'operator') {
        result += row.operatorValue + ' ';
      }
    });

    return result;
  }

  generateKibanaFilterScript(queryInput: string) {
    var commandsList = queryInput.trim().split(' ');
    var result = '';
    var hasArithmeticOperators = false;

    // First pass: Check if query contains arithmetic operators
    for (var i = 0; i < commandsList.length; i++) {
      if (['+', '-', '*', '/'].includes(commandsList[i].trim())) {
        hasArithmeticOperators = true;
        break;
      }
    }

    for (var index = 0; index < commandsList.length; index++) {
      switch (commandsList[index].trim()) {
        case '(':
          result += ' (';
          break;
        case ')':
          result += ' )';
          break;
        case 'AND':
          result += ' &&';
          break;
        case 'OR':
          result += ' ||';
          break;
        case 'NOT':
          result += '!';
          break;
        case '+':
          result += ' +';
          break;
        case '-':
          result += ' -';
          break;
        case '*':
          result += ' *';
          break;
        case '/':
          result += ' /';
          break;
        default: {
          //to handle commands
          // Check if it's a NUMERAL (number)
          if (!isNaN(Number(commandsList[index].trim()))) {
            result += ' ' + commandsList[index].trim();
          } else if (commandsList[index].includes(':')) {
            // It's a metric with variableCode:responseCode format
            var variableCode = commandsList[index].split(':')[0];
            var responseCode = commandsList[index].split(':')[1].split(',');

            if (hasArithmeticOperators) {
              // For arithmetic operations, return 1 or 0
              result += ' (';
              for (var r = 0; r < responseCode.length; r++) {
                if (r != 0) result += ' || ';
                result += `(doc.containsKey('${variableCode}') && doc['${variableCode}'].size() > 0 && (((doc['${variableCode}'].value instanceof double||doc['${variableCode}'].value instanceof float) && doc['${variableCode}'].value==Double.parseDouble('${responseCode[r]}')) || ((doc['${variableCode}'].value instanceof long||doc['${variableCode}'].value instanceof int) && doc['${variableCode}'].value==Long.parseLong('${responseCode[r]}')) || (doc['${variableCode}'].value instanceof String && doc['${variableCode}'].value=='${responseCode[r]}')))`;
              }
              result += ' ? 1 : 0)';
            } else {
              // For logical operations, return boolean
              result += ' (';
              for (var r = 0; r < responseCode.length; r++) {
                if (r != 0) result += ' || ';
                result += `(doc.containsKey('${variableCode}') && doc['${variableCode}'].size() > 0
              &&  (((doc['${variableCode}'].value instanceof double||doc['${variableCode}'].value instanceof float) && doc['${variableCode}'].value==Double.parseDouble('${responseCode[r]}'))
                      || ((doc['${variableCode}'].value instanceof long||doc['${variableCode}'].value instanceof int) && doc['${variableCode}'].value==Long.parseLong('${responseCode[r]}'))
                      || (doc['${variableCode}'].value instanceof String && doc['${variableCode}'].value=='${responseCode[r]}')))`;
              }
              result += ')';
            }
          }
        }
      }
    }
    return result;
  }


  CustomCalculationSaveSelection(eventData: {
    isValidationPass: boolean;
    selectionName: string;
    isUpdate: boolean;
    isDuplicate: boolean;
  }): void {
    if (eventData.isValidationPass) {
      this._loaderService.showLoader();

      //generate custom group html to bind in summary
      this.generateCustomCalculationHtml();
      // const queryInput = this.generateCustomCalculationQueryInput(
      //   this.customCalculationSelectionsObj
      // );

      //const kibanaQuery = this.generateKibanaQuery(queryInput);
      // const kibanaFilterScript =
      //   this.generateKibanaFilterScriptCustomCalc(queryInput);

      //create selection objects to bind back all the selections
      var tempObj = {
        listCustomCalculationItemsList: this.listCustomCalculationItemsList, //drag and drop object
        customCalculationSelectionsObj: this.customCalculationSelectionsObj, //custom group selecito object
        customCalculationDataObj: this.dataObject['CustomCalculation'],
      };
      let data: any = {};
      let user = localStorage.getItem('useremail');
      if (eventData.isUpdate) {
        data = _.cloneDeep(this.existingData.find((r: any) => r.selection_name == eventData.selectionName));
        if (data) {
          data.selection_object = JSON.stringify(tempObj);
          data.isUpdate = true;
          data.modified_by = user;
          data.modified_date = new Date().toLocaleString()
        }

      }
      else if(this.isDeleteCustomGrouporCalculation){
        data = _.cloneDeep(this.existingData.find((r: any) => r.selection_name == eventData.selectionName));
        if (data) {
          data.soft_delete = "1";
          data.isUpdate = true;
          data.modified_by = user;
          data.modified_date = new Date().toLocaleString()
        }
      }

      else {
       data = {
          created_by: user,
          created_date: new Date().toLocaleString(),
          module_id: COMMON_CONSTANTS.DataExplorerModuleId,
          selection_name: eventData.selectionName,
          client_name: this.clientDetails.clientDetails.client_name,
          study: this.clientDetails.clientDetails.selectedStudy,
          selection_query: "",
          selection_query_answerbase: "",
          selection_object: JSON.stringify(tempObj),
          modified_by: '',
          shared_with: [],
          is_active: true,
          is_shared: false,
          sortid: 0,
          isUpdate: eventData.isUpdate, //true to update , false to save,
          isDuplicate: eventData.isDuplicate,
          soft_delete: "0",
          soft_delete_date: null,
          permanent_delete: "0",
          permanent_delete_date: null,
          user_name: user,
          modified_date: "",
          selection_type: "CustomCalculation"
        }
      }
      let isSubmit = true;
      if (this.existingData != null && this.existingData != undefined && !eventData.isUpdate && !this.isDeleteCustomGrouporCalculation) {
        // Assume `this.existingData` is already defined
        // Replace `data` with the actual data you want to push

        // Access snapshotType
        if(!this.isDuplicateClicked){
        const item = this.existingData.find(
          (type: any) => type.selection_name === eventData.selectionName
        );

        if (item) {
          this.errorPopup('Record already exists.', 'Alert');
          isSubmit = false;
        }
      }
      else{
        const items = this.existingData.filter(
          (type: any) => type.selection_name === eventData.selectionName
        );

        if (items.length>1) {
          this.errorPopup('Record already exists.', 'Alert');
          isSubmit = false;
        }
      }


      }
      if (isSubmit) {
        this._configCustomService.saveCustomMetricSnapshotWidgetLibrary(data).subscribe(
          (response: any) => {

            if (response.Data != "") {

              if(this.isDeleteCustomGrouporCalculation){
                this.errorPopup(response.Data.replace("Document updated successfully","Custom Metric deleted successfully."), 'Alert');
              }
              else{
              this.errorPopup(response.Data.replace("Document","Custom Metric"), 'Alert');}
              if (!eventData.isUpdate && !this.isDeleteCustomGrouporCalculation) { this.existingData.push(data); }
              else {
                let selectionIndex = this.existingData.findIndex((r: any) => r.selection_name == eventData.selectionName);
                if (selectionIndex != -1) {
                  this.existingData[selectionIndex] = data;
                }
                if(this.isDeleteCustomGrouporCalculation){
                  this.existingData = this.existingData.filter((r: any) => r.selection_name != eventData.selectionName);
                  this.isDeleteCustomGrouporCalculation=false;
                }
              }
              this.existing_custom_metric_details = [];
              // this.initialCall();
              // this.existing_custom_metric = this.getUniqueSelectionNames(this.existingData, this._configCustomService.selectedSnapshotType?.name, this._configCustomService.selectedSection, this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "" ? "NA" : this._configCustomService.selectedSubsection);
              // this.existing_custom_metric = this.existing_custom_metric.map((m: any) => ({ name: m, isSelected: false }));
              this.setCustomMetricList();
              this.clearCustomCalculationSelection();
              this.cdRef.detectChanges();
              this.isSaveCustomGroupSelectionClick = false;
              this.isSaveCustomCalculationSelectionClick = false;
              this.isEditClicked=false;
              this.selectedCustomCalculationName = '';
              this.isUpdateCustomCalculation = false;
            }
            else {
              this.errorPopup('Some Error Occured.', 'Alert');
              this.isSaveCustomGroupSelectionClick = false;
              this.isSaveCustomCalculationSelectionClick = false;
            }
            this._loaderService.hideLoader();
          }
        );
        if(eventData.isDuplicate){
          let item = this.existingData.find((r: any) => r.selection_name == this.customGroupSelectionName);
          if(item){
            item.selection_name = eventData.selectionName;
          }
          this.isDuplicateClicked=false;
          this.customGroupSelectionName = '';
        }
      }





    }
  }

  CustomGroupSaveSelection(eventData: {
    isValidationPass: boolean;
    selectionName: string;
    isUpdate: boolean;
    isDuplicate: boolean;
  }): void {
    if (eventData.isValidationPass) {
      this._loaderService.showLoader();

      // //generate custom group html to bind in summary
      this.generateCustomGroupHtml();
      const queryInput = this.generateCustomGroupQueryInput(
        this.customGroupSelectionsObj
      );

      //const kibanaQuery = this.generateKibanaQuery(queryInput);
      const kibanaFilterScript = this.generateKibanaFilterScript(queryInput);


      //create selection objects to bind back all the selections
      var tempObj = {
        listCustomGroupItemsList: this.listCustomGroupItemsList, //drag and drop object
        customGroupSelectionsObj: this.customGroupSelectionsObj, //custom group selecito object
        customGroupDataObj: this.dataObject['CustomGroup'],
      };

      this._loaderService.hideLoader();

      let data: any = {};
      let user=localStorage.getItem('useremail');
      if (eventData.isUpdate) {
        data = _.cloneDeep(this.existingData.find((r: any) => r.selection_name == eventData.selectionName));
        if (data) {
          data.selection_object = JSON.stringify(tempObj);
          data.isUpdate = true;
          data.modified_by = user;
          data.modified_date = new Date().toLocaleString();
          data.selection_query = JSON.stringify(kibanaFilterScript);
        }

      }
      else if(this.isDeleteCustomGrouporCalculation){
        data = _.cloneDeep(this.existingData.find((r: any) => r.selection_name == eventData.selectionName));
        if (data) {
          data.soft_delete = "1";
          data.soft_delete_date= new Date().toLocaleString();
          data.permanent_delete= "0";
          data.permanent_delete_date= null;
          data.isUpdate = true;
          data.modified_by = user;
          data.modified_date = new Date().toLocaleString();
          data.is_active = false;
        }
      }
      else {
        data = {
          created_by: user,
          created_date: new Date().toLocaleString(),
          module_id: COMMON_CONSTANTS.DataExplorerModuleId,
          selection_name: eventData.selectionName,
          client_name: this.clientDetails.clientDetails.client_name,
          study: this.clientDetails.clientDetails.selectedStudy,
          selection_query:  JSON.stringify(kibanaFilterScript),
          selection_query_answerbase: "",
          selection_object: JSON.stringify(tempObj),
          modified_by: '',
          shared_with: [],
          is_active: true,
          is_shared: false,
          sortid: 0,
          isUpdate: eventData.isUpdate, //true to update , false to save,
          isDuplicate: eventData.isDuplicate,
          soft_delete: "0",
          soft_delete_date: null,
          permanent_delete: "0",
          permanent_delete_date: null,
          user_name: user,
          modified_date: "",
          selection_type: "CustomGroup"
        }
      }
      let isSubmit = true;
      if (this.existingData != null && this.existingData != undefined && !eventData.isUpdate && !this.isDeleteCustomGrouporCalculation) {
        // Assume `this.existingData` is already defined
        // Replace `data` with the actual data you want to push

        // Access snapshotType
        if(!this.isDuplicateClicked){
        const item = this.existingData.find(
          (type: any) => type.selection_name === eventData.selectionName
        );

        if (item) {
          this.errorPopup('Record already exists.', 'Alert');
          isSubmit = false;
        }
      }
      else{
        const items = this.existingData.filter(
          (type: any) => type.selection_name === eventData.selectionName
        );

        if (items.length>1) {
          this.errorPopup('Record already exists.', 'Alert');
          isSubmit = false;
        }
      }


      }
      if (isSubmit) {
        this._configCustomService.saveCustomMetricSnapshotWidgetLibrary(data).subscribe(
          (response: any) => {

            if (response.Data != "") {
              if(this.isDeleteCustomGrouporCalculation){
                this.errorPopup(response.Data.replace("Document updated successfully","Custom Metric deleted successfully."), 'Alert');
              }
              else{
              this.errorPopup(response.Data.replace("Document","Custom Metric"), 'Alert');}
              if (!eventData.isUpdate && !this.isDeleteCustomGrouporCalculation) { this.existingData.push(data); }
              else {
                let selectionIndex = this.existingData.findIndex((r: any) => r.selection_name == eventData.selectionName);
                if (selectionIndex != -1) {
                  this.existingData[selectionIndex] = data;
                }
                if(this.isDeleteCustomGrouporCalculation){
                  this.existingData = this.existingData.filter((r: any) => r.selection_name != eventData.selectionName);
                  this.isDeleteCustomGrouporCalculation=false;
                }
              }
              this.existing_custom_metric_details = [];
              // this.initialCall();
              this.setCustomMetricList();
              this.clearCustomGroupSelection();
              this.cdRef.detectChanges();
              this.isSaveCustomGroupSelectionClick = false;
              this.isEditClicked=false;
              this.selectedCustomGroupName = '';
              this.isUpdateCustomGroup = false;
            }
            else {
              this.errorPopup('Some Error Occured.', 'Alert');
              this.isSaveCustomGroupSelectionClick = false;
            }
          }
        );
        if(eventData.isDuplicate){
          let item = this.existingData.find((r: any) => r.selection_name == this.customGroupSelectionName);
          if(item){
            item.selection_name = eventData.selectionName;
          }
          this.isDuplicateClicked=false;
          this.customGroupSelectionName = '';
        }
      }


    }
  }



  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }

  validateCustomGroupDropDowns() {
    var jsonDataList = this.customGroupSelectionsObj;
    var areAllDropDownsValid = {
      valid: true,
      invalidObject: '',
    };
    if (_.filter(jsonDataList, (s) => s.type == 'metric').length == 0)
      //minimum one metric should be selected
      areAllDropDownsValid.valid = false;
    else {
      for (var i in jsonDataList) {
        if (
          jsonDataList != null &&
          jsonDataList != undefined &&
          jsonDataList.length > 0 &&
          jsonDataList[i].type == 'metric'
        ) {
          if (
            Object.keys(jsonDataList[i].oneObject).length === 0 ||
            jsonDataList[i].oneObject.Data.length == 0
          ) {
            areAllDropDownsValid.valid = false;
            //  areAllDropDownsValid.invalidObject = (jsonDataList[i].oneObject.label!=null && jsonDataList[i].oneObject.label!= undefined && jsonDataList[i].oneObject.label!="")
            //  										?jsonDataList[i].oneObject.label:jsonDataList[i].oneObject.group;
            break;
          }
        }
      }
    }
    return areAllDropDownsValid;
  }



  ParenthesisCheck(customType: string = 'customGroup') {
    var jsonDataList;
    if (customType == 'customCalculation') {
      jsonDataList = this.customCalculationSelectionsObj;
    } else {
      jsonDataList = this.customGroupSelectionsObj;
    }
    var parenthesisCheck = true;
    var openParenthesisLength = 0;
    var closeParenthesisLength = 0;
    for (var i in jsonDataList) {
      if (jsonDataList[i].type == 'metric') {
        continue;
      } else if (
        jsonDataList[i].type == 'operator' &&
        jsonDataList[i].operatorValue == '('
      ) {
        openParenthesisLength++;
      } else if (
        jsonDataList[i].type == 'operator' &&
        jsonDataList[i].operatorValue == ')'
      ) {
        closeParenthesisLength++;
      }
    }
    if (openParenthesisLength == closeParenthesisLength) {
      parenthesisCheck = true;
    } else {
      parenthesisCheck = false;
    }

    if (parenthesisCheck == true) {
      if (
        jsonDataList != null &&
        jsonDataList != undefined &&
        jsonDataList.length > 0 &&
        jsonDataList[jsonDataList.length - 1].type == 'operator' &&
        jsonDataList[jsonDataList.length - 1].operatorValue != ')'
      ) {
        parenthesisCheck = false;
      }
    }
    return parenthesisCheck;
  }



  validateCustomGroupSummary() {
    const logicalOps    = ['NOT', 'AND', 'OR'];
    const arithmeticOps = ['+', '-', '*', '/', 'NUMERAL'];

    var jsonDataList = this.customGroupSelectionsObj;
    var validationResult: { isSelectionValid: boolean; invalidObject: any; messageForerror: string } = {
      isSelectionValid: true,
      invalidObject: {},
      messageForerror: '',
    };

    // --- Sequential token-by-token transition check (existing logic) ---
    var previousSelection = '';
    for (var i in jsonDataList) {
      if (validationResult.isSelectionValid) {
        var currentSelection = '';

        if (previousSelection == '') {
          if (jsonDataList[i].type == 'metric') {
            previousSelection = 'metric';
          } else {
            previousSelection = jsonDataList[i].operatorValue;
          }
        } else {
          if (jsonDataList[i].type == 'metric') {
            currentSelection = 'metric';
          } else {
            currentSelection = jsonDataList[i].operatorValue;
          }

          for (var j in customGroupsvalidationRules) {
            if (
              previousSelection != null &&
              previousSelection != undefined &&
              previousSelection.toLowerCase() ==
              customGroupsvalidationRules[j].latestSelection.toLowerCase()
            ) {
              if (
                customGroupsvalidationRules[j].itemsToBeEnabled.indexOf(
                  currentSelection.toUpperCase()
                ) >= 0 ||
                customGroupsvalidationRules[j].itemsToBeEnabled.indexOf(
                  currentSelection.toLowerCase()
                ) >= 0
              ) {
              } else {
                validationResult.isSelectionValid = false;
                validationResult.invalidObject = jsonDataList[i];
              }
              break;
            }
          }

          previousSelection = currentSelection;
        }
      } else {
        break;
      }
    }

    if (!validationResult.isSelectionValid) return validationResult;

    // --- Rule 1: No mixing of logical and arithmetic within the same group ---
    // e.g.  (NPS 1 + Aware 2 AND NPS 6)  is invalid
    const groupMap = this.getGroupOperatorMap(jsonDataList);
    for (const [, group] of groupMap) {
      const hasLogical    = logicalOps.some(op => group.operators.has(op));
      const hasArithmetic = arithmeticOps.some(op => group.operators.has(op));
      if (hasLogical && hasArithmetic) {
        validationResult.isSelectionValid = false;
        validationResult.messageForerror  =
          "Invalid formula: logical (AND/OR/NOT) and arithmetic (+/-/*/÷) operators cannot be mixed within the same group.";
        return validationResult;
      }
    }

    // --- Rule 2: If the top-level connector is logical, inner groups must also be logical ---
    // e.g.  (A AND B) AND (C + D)  is invalid  — logical top-level, arithmetic inner group
    //       (A * B)   OR  (C AND D) is invalid  — logical top-level, arithmetic inner group
    //       (A AND B) -   (C * D)  is valid     — arithmetic top-level, mixed types allowed
    //       (A * B)   +   (C AND D) is valid    — arithmetic top-level, mixed types allowed
    const topLevelOps        = groupMap.get(0)?.operators ?? new Set<string>();
    const topLevelHasLogical = logicalOps.some(op => topLevelOps.has(op));
    if (topLevelHasLogical) {
      for (const [groupId, group] of groupMap) {
        if (groupId !== 0 && arithmeticOps.some(op => group.operators.has(op))) {
          validationResult.isSelectionValid = false;
          validationResult.messageForerror  =
            "Invalid formula: when the top-level connector is logical (AND/OR), all inner groups must also use only logical operators.";
          return validationResult;
        }
      }
    }

    // --- Rule 3: At most 2 parenthesis groups are allowed in a formula ---
    const topLevelGroups = Array.from(groupMap.values()).filter(g => g.depth === 1);
    if (topLevelGroups.length > 2) {
      validationResult.isSelectionValid = false;
      validationResult.messageForerror  = "Invalid formula: at most 2 groups are allowed.";
    }

    // --- Rule 4: All metrics must be inside groups (no flat/bare top-level formulas) ---
    if (validationResult.isSelectionValid) {
      let d = 0;
      const hasTopLevelMetric = jsonDataList.some((token: any) => {
        if (token.operatorValue === '(') { d++; return false; }
        if (token.operatorValue === ')') { d--; return false; }
        return token.type === 'metric' && d === 0;
      });
      if (hasTopLevelMetric) {
        validationResult.isSelectionValid = false;
        validationResult.messageForerror  =
          "Invalid formula: all metrics must be inside parenthesis groups.";
      }
    }

    return validationResult;
  }




  isSavedScenarioSelected: boolean = false;
  displayMainComponent: boolean = false;
  isCreateCustomGroup: boolean = false;
  isUpdateCustomGroup: boolean = false;
  selectedCustomGroupName: string = '';
  isDeleteCustomGroup: boolean = false;
  isDuplicateCustomGroup: boolean = false;
  isShareCustomGroupPopupClick: boolean = false;
  selectedCustomGroupName_Bucket: string = '';
  isMeanMetric: boolean = false;
  isShareMetric: boolean = false;
  isCustomGroupClick: boolean = false;
  isSaveSelection: boolean = false;
  isLoadSelection: boolean = false;
  isCreateTable: boolean = false;
  isCustomGroupPopupClick: boolean = false;
  isCustomCalculationPopupClick: boolean = false;
  isCustomCalculationClick: boolean = false;
  isCustomGroupPopup: boolean = false;
  isCustomCalculationPopup: boolean = false;
  isCustomGroup: boolean = false;
  isCustomCalculation: boolean = false;


  onUpdate(item: any) {
    let event: {
      displayMainComponent: boolean;
      isCreateCustomGroup: boolean;
      isUpdateCustomGroup: boolean;
      isDeleteCustomGroup: boolean;
      isDuplicateCustomGroup: boolean;
      isShareCustomGroup: boolean;
      selectedCustomGroupName: string;
      selectedCustomGroupName_Bucket: string;
      customGroupId: string;
      isShareMetric: boolean;
      isMeanMetric: boolean;
    } = {
      displayMainComponent: false,
      isUpdateCustomGroup: true,
      isCreateCustomGroup: false,
      isDeleteCustomGroup: false,
      isDuplicateCustomGroup: false,
      isShareCustomGroup: false,
      selectedCustomGroupName: item.name,
      selectedCustomGroupName_Bucket: "userDefined",
      customGroupId: "",
      isShareMetric: false,
      isMeanMetric: true
    };

    let calculationEvent: {
      displayMainComponent: boolean;
      isCreateCustomCalculation: boolean;
      isUpdateCustomCalculation: boolean;
      isDeleteCustomCalculation: boolean;
      isDuplicateCustomCalculation: boolean;
      isShareCustomCalculation: boolean;
      selectedCustomCalculationName: string;
      selectedCustomCalculationName_Bucket: string;
      customCalculationId: string;
      isMeanMetric: boolean;
      isShareMetric: boolean;
      isCreateCustomGroup: boolean;
    } = {
      displayMainComponent: false,
      isCreateCustomCalculation: false,
      isUpdateCustomCalculation: true,
      isDeleteCustomCalculation: false,
      isDuplicateCustomCalculation: false,
      isShareCustomCalculation: false,
      selectedCustomCalculationName: item.name,
      selectedCustomCalculationName_Bucket: "userDefined",
      customCalculationId: "",
      isMeanMetric: true,
      isShareMetric: false,
      isCreateCustomGroup: false
    };

    if (!this.isDuplicateCustomGroup) {
      this.isEditClicked = true;
    }
    this.existing_custom_metric.forEach((r: any) => {
      if (r.name == item.name) {
        r.isSelected = true;
      }
      else {
        r.isSelected = false;
      }
    }
    );
    if (this.isCustomMeanMetric) {
      this.bindCustomCalculationFlags(calculationEvent);
    }
    if (this.isCustomMetricPercentage) {
      this.bindCustomGroupFlags(event);
    }
  }

  bindCustomGroupFlags(eventData: {
    displayMainComponent: boolean;
    isCreateCustomGroup: boolean;
    isUpdateCustomGroup: boolean;
    isDeleteCustomGroup: boolean;
    isDuplicateCustomGroup: boolean;
    isShareCustomGroup: boolean;
    selectedCustomGroupName: string;
    selectedCustomGroupName_Bucket: string;
    customGroupId: string;
    isShareMetric: boolean;
    isMeanMetric: boolean;
  }) {
    this.isSavedScenarioSelected = false;
    this.clearSelection('CustomGroup'); //clear already existing contents
    this.displayMainComponent = eventData.displayMainComponent;
    this.isCreateCustomGroup = eventData.isCreateCustomGroup;
    this.isUpdateCustomGroup = eventData.isUpdateCustomGroup;
    this.selectedCustomGroupName = eventData.selectedCustomGroupName;
    this.isDeleteCustomGroup = eventData.isDeleteCustomGroup;
    this.isDuplicateCustomGroup = eventData.isDuplicateCustomGroup;
    this.isShareCustomGroupPopupClick = eventData.isShareCustomGroup;
    this.selectedCustomGroupName_Bucket =
      eventData.selectedCustomGroupName_Bucket;
    this.isMeanMetric = eventData.isMeanMetric;
    this.isShareMetric = eventData.isShareMetric;
    if (!this.isDeleteCustomGroup && !this.isShareCustomGroupPopupClick) {
      this.isCustomGroupClick = false; //to close custom group popup
      this.isSaveSelection = false; //to hide save button
      this.isLoadSelection = false; //to create load button

      if (this.isDuplicateCustomGroup) this.isCreateTable = true;
      else this.isCreateTable = false; //to hide create table button
    }

    if (this.isCreateCustomGroup) {
      //add this operator on load
      this.invokeValidationRules('(');
      let event: Event = new Event('');
      this.customGroupSelectionsObj = [];
      this.bindCustomGroupOperatorClick(event, '(');
    } else if (this.isUpdateCustomGroup) {
      //rebind contents to update
      this.rebindCustomGroupView();
      //to display save custom group button
      this.isCreateCustomGroup = true;
      this.invokeValidationRules(')');
    } else if (this.isDeleteCustomGroup) {
      this.getCompleteCustomGroupInfo();
      this.bindDeleteCustomGroup(eventData.customGroupId);
    } else if (this.isDuplicateCustomGroup) {
      this.bindDuplicateCustomGroup();
      this.invokeValidationRules(')');
    }
    this.customGroupItemIndex = -1;
  }


  isCreateCustomCalculation: boolean = false;
  isDeleteCustomCalculation: boolean = false;
  isShareCustomCalculationPopupClick: boolean = false;
  selectedCustomCalculationName_Bucket: string = '';
  bindCustomCalculationFlags(eventData: {
    displayMainComponent: boolean;
    isCreateCustomCalculation: boolean;
    isUpdateCustomCalculation: boolean;
    isDeleteCustomCalculation: boolean;
    isDuplicateCustomCalculation: boolean;
    isShareCustomCalculation: boolean;
    selectedCustomCalculationName: string;
    selectedCustomCalculationName_Bucket: string;
    customCalculationId: string;
    isMeanMetric: boolean;
    isShareMetric: boolean;
    isCreateCustomGroup: boolean;
  }) {
    this.isCreateCustomGroup = eventData.isCreateCustomGroup;
    this.isSavedScenarioSelected = false;
    this.clearSelection('CustomCalculation'); //clear already existing contents
    this.displayMainComponent = eventData.displayMainComponent;
    this.isCreateCustomCalculation = eventData.isCreateCustomCalculation;
    this.isUpdateCustomCalculation = eventData.isUpdateCustomCalculation;
    this.selectedCustomCalculationName =
      eventData.selectedCustomCalculationName;
    this.isDeleteCustomCalculation = eventData.isDeleteCustomCalculation;
    this.isDuplicateCustomCalculation = eventData.isDuplicateCustomCalculation;
    this.isShareCustomCalculationPopupClick =
      eventData.isShareCustomCalculation;
    this.selectedCustomCalculationName_Bucket =
      eventData.selectedCustomCalculationName_Bucket;
    this.isMeanMetric = true;
    this.isShareMetric = false;
    if (
      !this.isDeleteCustomCalculation &&
      !this.isShareCustomCalculationPopupClick
    ) {
      this.isCustomGroupClick = false;
      this.isCustomCalculationClick = false; //to close custom group popup
      this.isSaveSelection = false; //to hide save button
      this.isLoadSelection = false; //to create load button

      if (this.isDuplicateCustomCalculation) this.isCreateTable = true;
      else this.isCreateTable = false; //to hide create table button
    }
    if (this.isCreateCustomCalculation) {
      //add this operator on load
      this.invokeValidationRulesCustomCalc('(', 1);
      let event: Event = new Event('');
      this.customCalculationSelectionsObj = [];
      this.bindCustomCalculationOperatorClick(event, '(');
    } else if (this.isUpdateCustomCalculation) {
      //rebind contents to update
      this.rebindCustomCalculationView();
      //to display save custom group button
      this.isCreateCustomCalculation = true;
      this.invokeValidationRulesCustomCalc(')');
    } else if (this.isDeleteCustomCalculation) {
      this.getCompleteCustomCalculationInfo();
      this.bindDeleteCustomCalculation(eventData.customCalculationId);
    } else if (this.isDuplicateCustomCalculation) {
      this.bindDuplicateCustomCalculation();
      this.invokeValidationRulesCustomCalc(')');
    } else if (this.isShareCustomCalculationPopupClick) {
      this.getCompleteCustomCalculationInfo(); //update currently selected custom group data obj
      this.bindShareCustomGroup('Custom Calculation');
    }
    this.customCalculationItemIndex = -1;

    // if (this.isCreateCustomCalculation) {
    //   //add this operator on load
    //   this.invokeValidationRulesCustomCalc('(');
    //   let event: Event = new Event('');
    //   this.customCalculationSelectionsObj = [];
  }

  bindShareCustomGroup(item: any) {

  }

  selectedCustomCalculationObj: any;
  getCompleteCustomCalculationInfo() {
    var customCalculationData =
      this.selectedCustomCalculationName_Bucket == 'userDefined'
        ? this.loadCustomCalculationUserDefinedData
        : this.loadCustomCalculationSharedWithMeData;
    //only user defined custom group can be shared
    this.selectedCustomCalculationObj = _.filter(
      customCalculationData,
      (r) =>
        r.selection_name === this.selectedCustomCalculationName &&
        r.client_name === this.selected_client &&
        r.study === this.selected_study
      // r.module_id === this.selected_module
    )[0];

    //update the selected object to shared list
    //this.loadSharedWithMeSavedScenarioData.push(this.selectedCustomGroupObj);
  }



  bindDuplicateCustomGroup() {
    this.isSavedScenarioSelected = false;
    this.isCustomGroupClick = false; //close custom group popup
    this.isCreateCustomGroup = true; //bind all contents similar to create customgroup
    this.rebindCustomGroupView(); //to bind all the data objects
  }

  bindDuplicateCustomCalculation() {
    this.isSavedScenarioSelected = false;
    this.isCustomCalculationClick = false; //close custom Calculation popup
    this.isCreateCustomCalculation = true; //bind all contents similar to create customCalculation
    this.rebindCustomCalculationView(); //to bind all the data objects
  }

  bindDeleteCustomGroup(customGroupId: string) {

  }
  bindDeleteCustomCalculation(customCalculationId: string) {

  }

  selectedCustomGroupObj: any;
  selected_client: string = '';
  selected_study: string = '';
  getCompleteCustomGroupInfo() {
    var customGroupData =
      this.selectedCustomGroupName_Bucket == 'userDefined'
        ? this.loadCustomGroupUserDefinedData
        : this.loadCustomGroupSharedWithMeData;
    //only user defined custom group can be shared
    this.selectedCustomGroupObj = _.filter(
      customGroupData,
      (r) =>
        r.selection_name === this.selectedCustomGroupName &&
        r.client_name === this.selected_client &&
        r.study === this.selected_study
      // r.module_id === this.selected_module
    )[0];

    //update the selected object to shared list
    //this.loadSharedWithMeSavedScenarioData.push(this.selectedCustomGroupObj);
  }
  isEditClicked: boolean = false;
  cancelEdit() {
    this.isEditClicked = false;
    this.isUpdateCustomGroup=false;
    this.isUpdateCustomCalculation=false;
    this.existing_custom_metric.forEach((r: any) => {
      r.isSelected = false;
    });
    this.selectedCustomGroupName = '';
    this.selectedCustomCalculationName = '';
    if (!this.isCustomMeanMetric) {
      this.clearCustomGroupSelection();
    }
    else {
      this.clearCustomCalculationSelection();
    }
    if(this.isDuplicateClicked){
      this.isDuplicateClicked=false;
      this.existing_custom_metric=this.existing_custom_metric.filter((r:any)=>r.selection_name!=this.customGroupSelectionName);
      this.existingData=this.existingData.filter((r:any)=>r.selection_name!=this.customGroupSelectionName);
      this.setCustomMetricList();
      this.customGroupSelectionName='';
    }
  }

  loadCustomGroupUserDefinedData: any;
  loadCustomGroupSharedWithMeData: any;
  rebindCustomGroupView() {
    var customGroupData;
    if (this.selectedCustomGroupName_Bucket == 'userDefined')
      customGroupData = this.loadCustomGroupUserDefinedData;
    else customGroupData = this.loadCustomGroupSharedWithMeData;
    var selectedCustomGroupObj = this.existing_custom_metric_details.filter(
      (a: any) => a.selection_name === this.selectedCustomGroupName && a.selection_type == "CustomGroup"
    );

    var selectionObject = JSON.parse(
      selectedCustomGroupObj[0].selection_object
    );

    //to bind custom group selections
    this.customGroupSelectionsObj = selectionObject.customGroupSelectionsObj;
    //to bind left panel selections in custom group view
    this.listCustomGroupItemsList = selectionObject.listCustomGroupItemsList;

    this.metrics.forEach((m: any) => {
      m.isSelected = false;
    });

    //to bind custom group selections

    this.checkIfMetricInFomPresent();

    var tempRowOrder;
    // Check if 'customGroupRowOrder' is not already a property in the 'listCustomGroupItemsList' objects
    if (
      !this.listCustomGroupItemsList.some((e) => 'customGroupRowOrder' in e)
    ) {
      // If 'customGroupRowOrder' is not a property, execute the loop
      this.listCustomGroupItemsList.forEach((e) => {
        var tempRowOrder = _.filter(
          this.customGroupSelectionsObj,
          (r: any) => r.headerText == e.Level1
        )[0]?.rowOrder;
        e.customGroupRowOrder = tempRowOrder;
      });
    }

    this.dataObject['CustomGroup'] = selectionObject.customGroupDataObj;

    // Check if 'customGroupRowOrder' is not already a property in the 'CustomGroup' objects
    if (
      !this.dataObject['CustomGroup'].some((e) => 'customGroupRowOrder' in e)
    ) {
      // If 'customGroupRowOrder' is not a property, execute the loop
      this.dataObject['CustomGroup'].forEach((e) => {
        var tempRowOrder = _.filter(
          this.customGroupSelectionsObj,
          (r: any) => r.headerText == e.Parent
        )[0]?.rowOrder;
        e.customGroupRowOrder = tempRowOrder;
      });
    }
  }

  loadCustomCalculationUserDefinedData: any;
  loadCustomCalculationSharedWithMeData: any;
  rebindCustomCalculationView() {
    var customCalculationData;
    if (this.selectedCustomCalculationName_Bucket == 'userDefined')
      customCalculationData = this.loadCustomCalculationUserDefinedData;
    else customCalculationData = this.loadCustomCalculationSharedWithMeData;
    var selectedCustomCalculationObj = this.existing_custom_metric_details.filter(
      (a: any) => a.selection_name === this.selectedCustomCalculationName && a.selection_type == "CustomCalculation"
    );


    var selectionObject = JSON.parse(
      selectedCustomCalculationObj[0].selection_object
    );

    //to bind custom group selections
    this.customCalculationSelectionsObj =
      selectionObject.customCalculationSelectionsObj;
    //to bind left panel selections in custom group view
    this.listCustomCalculationItemsList =
      selectionObject.listCustomCalculationItemsList;

    this.metrics.forEach((m: any) => {
      m.isSelected = false;
    });

    //to bind custom calculation selections

    this.checkIfMetricInFomPresent();

    var tempRowOrder;
    // Check if 'customGroupRowOrder' is not already a property in the 'listCustomGroupItemsList' objects
    if (
      !this.listCustomCalculationItemsList.some(
        (e: any) => 'customCalculationRowOrder' in e
      )
    ) {
      // If 'customGroupRowOrder' is not a property, execute the loop
      this.listCustomCalculationItemsList.forEach((e: any) => {
        var tempRowOrder = _.filter(
          this.customCalculationSelectionsObj,
          (r: any) => r.headerText == e.Level1
        )[0]?.rowOrder;
        e.customCalculationRowOrder = tempRowOrder;
      });
    }

    this.dataObject['CustomCalculation'] =
      selectionObject.customCalculationDataObj;

    // Check if 'customGroupRowOrder' is not already a property in the 'CustomGroup' objects
    if (
      !this.dataObject['CustomCalculation'].some(
        (e) => 'customCalculationRowOrder' in e
      )
    ) {
      // If 'customGroupRowOrder' is not a property, execute the loop
      this.dataObject['CustomCalculation'].forEach((e) => {
        var tempRowOrder = _.filter(
          this.customCalculationSelectionsObj,
          (r: any) => r.headerText == e.Parent
        )[0]?.rowOrder;
        e.customCalculationRowOrder = tempRowOrder;
      });
    }
  }

  checkIfMetricInFomPresent() {
    if (this.isCustomMetricPercentage) {
      this.listCustomGroupItemsList.forEach((r: any) => {
        let m = this.metrics.find((m: any) => m.option === r.Level1);
        if (m) {
          m.isSelected = true;
        }
        else {
          this.customGroupSelectionsObj.forEach((m: any) => {
            if (m.displayString === r.Level1) {
              m.notFound = true;
            }

          });
          this.existing_custom_metric.forEach((m: any) => {
            if (m.name === this.selectedCustomGroupName) {
              m.notFound = true;
            }
          });
          this.errorPopup('The custom metrics highlighted in red include some metrics that are no longer available in the mapping. Please update them accordingly.', 'Alert');
        }
      }
      );
    }
    if (this.isCustomMeanMetric) {
      this.listCustomCalculationItemsList.forEach((r: any) => {
        let m = this.metrics.find((m: any) => m.option === r.Level1);
        if (m) {
          m.isSelected = true;
        }
        else {
          this.customCalculationSelectionsObj.forEach((m: any) => {
            if (m.displayString === r.Level1) {
              m.notFound = true;
            }

          });
          this.existing_custom_metric.forEach((m: any) => {
            if (m.name === this.selectedCustomCalculationName) {
              m.notFound = true;
            }
          });
          this.errorPopup('The custom metrics highlighted in red include some metrics that are no longer available in the mapping. Please update them accordingly.', 'Alert');
        }
      }
      );
    }
  }

  getGroupedData(
    data: {
      WidgetMapping_Variables: string;
      WidgetMapping_VariableGroups: string;
    }[]
  ): { metricgroup: string; metrics: string[] }[] {
    const groups: { [key: string]: Set<string> } = {};

    data.forEach((item) => {
      if (!groups[item.WidgetMapping_VariableGroups]) {
        groups[item.WidgetMapping_VariableGroups] = new Set();
      }
      groups[item.WidgetMapping_VariableGroups].add(
        item.WidgetMapping_Variables
      );
    });

    const result: { metricgroup: string; metrics: string[] }[] = [];

    for (const group in groups) {
      if (groups.hasOwnProperty(group)) {
        result.push({
          metricgroup: group,
          metrics: Array.from(groups[group]),
        });
      }
    }

    return result;
  }
  CustomMetricClicked(item: any) {

    if (item == "custommeanmetric") {
      this.isCustomMeanMetric = true;
      this.isCustomMetricPercentage = false;
      this.clearCustomGroupSelection();
      this.clearCustomCalculationSelection();
      this.metrics = this.allmetrics.filter((m: any) => m.calculationType == "mean");
      // let event: Event = new CustomEvent('customEvent', {
      //   detail: {
      //     displayMainComponent: false,
      //     isCreateCustomGroup: false,
      //     isDeleteCustomGroup: false,
      //     isDuplicateCustomGroup: false,
      //     isMeanMetric: true,
      //     isShareCustomGroup: false,
      //     isShareMetric: true,
      //     isUpdateCustomGroup: false
      //   }
      // });
      let event: Event = new Event('');
      // this.bindCustomCalculationOperatorClick(event, '(');
      this.setCustomMetricList();
    }
    if (item == "custommetricpercentage") {
      this.isCustomMeanMetric = false;
      this.isCustomMetricPercentage = true;
      this.customCalculationHtml = '';
      this.customCalculationQuery = '';
      this.customCalculationRowOrder = 1;
      this.customCalculationSelectionsObj = [];
      this.dataObject['CustomCalculation'] = [];
      this.listCustomCalculationItemsList = [];
      this.disabledCustomCalculationOperatorList = [];
      let event: Event = new Event('');
      this.customCalculationItemIndex = -1;
      this.clearCustomGroupSelection();
      this.metrics = this.allmetrics.filter((m: any) => m.calculationType === 'share');
      this.setCustomMetricList();
      // this.metri
    }
  }

  removeCustomGroup(
    variableCode: string,
    operatorValue: string,
    index: number,
    customGroupRowOrder?: number
  ) {
    let customObject = this.customGroupSelectionsObj;

    let dataObj = this.dataObject['CustomGroup'];
    //let listToUpdate = this.customGroupSelectionsObj;

    let obj: any = customObject.find((a) => a.rowOrder === customGroupRowOrder);
    let count=customObject.filter((a:any)=>a.displayString==obj.displayString).length;
    if (obj && count==1) {
      this.metrics.forEach((m: any) => {
        if (m.option === obj.displayString) {
          m.isSelected = false;
        }
      });
      this.cdRef.detectChanges();
    }

    let listToUpdate = customObject.filter(
      (a) => a.rowOrder !== customGroupRowOrder
    );
    this.customGroupSelectionsObj = listToUpdate;

    // Always recalculate button states after any removal.
    // Set the insertion point to the end of the remaining formula so that
    // getCurrentInsertionGroupId and checkOperatorTypeConflicts see the correct state.
    if (this.customGroupSelectionsObj.length > 0) {
      this.customGroupItemIndex = this.customGroupSelectionsObj.length - 1;
      const lastToken = this.customGroupSelectionsObj[this.customGroupItemIndex];
      const lastOpType = (lastToken.type === 'metric' || lastToken.operatorValue === '')
        ? 'metric'
        : lastToken.operatorValue;
      this.invokeValidationRules(lastOpType);
    } else {
      this.customGroupItemIndex = -1;
      this.disabledCustomGroupOperatorList = [];
    }

    //update dropped selected object

    this.dataObject['CustomGroup'] = this.dataObject['CustomGroup'].filter(
      (r) => r.customGroupRowOrder !== customGroupRowOrder
    );

    //update dropped objects
    this.listCustomGroupItemsList = this.listCustomGroupItemsList.filter(
      (r) => r.customGroupRowOrder !== customGroupRowOrder
    );
    if (this.customGroupSelectionsObj.length - 1 < this.customGroupItemIndex)
      this.customGroupItemIndex = this.customGroupSelectionsObj.length - 1;
  }

  removeCustomCalculation(
    variableCode: string,
    operatorValue: string,
    index: number,
    customCalculationRowOrder?: number
  ) {
    let customObject = this.customCalculationSelectionsObj;

    let dataObj = this.dataObject['CustomCalculation'];
    //let listToUpdate = this.customGroupSelectionsObj;

    let obj: any = customObject.find((a) => a.rowOrder === customCalculationRowOrder);
    let count=customObject.filter((a:any)=>a.displayString==obj.displayString).length;
    if (obj && count==1) {
      this.metrics.forEach((m: any) => {
        if (m.option === obj.displayString) {
          m.isSelected = false;
        }
      });
      this.cdRef.detectChanges();
    }

    let listToUpdate = customObject.filter(
      (a) => a.rowOrder !== customCalculationRowOrder
    );
    this.customCalculationSelectionsObj = listToUpdate;

    let operatorCheck = this.customCalculationSelectionsObj.filter(
      (a) => a.operatorValue == operatorValue
    );
    if (operatorCheck.length == 0) {
      var lastIndex = this.customCalculationSelectionsObj.length;
      //enable operators for based on last selection made in the custom Group selected value
      var previousOperatorValue =
        this.customCalculationSelectionsObj[lastIndex - 1].operatorValue;
      previousOperatorValue =
        previousOperatorValue == '' ? 'metric' : previousOperatorValue;
      let event: Event = new Event('');

      this.invokeValidationRulesCustomCalc(previousOperatorValue);
    }

    //update dropped selected object

    this.dataObject['CustomCalculation'] = this.dataObject['CustomCalculation'].filter(
      (r) => r.customGroupRowOrder !== customCalculationRowOrder
    );

    //update dropped objects
    this.listCustomCalculationItemsList = this.listCustomCalculationItemsList.filter(
      (r: any) => r.customGroupRowOrder !== customCalculationRowOrder
    );
    if (this.customCalculationSelectionsObj.length - 1 < this.customCalculationItemIndex)
      this.customCalculationItemIndex = this.customCalculationSelectionsObj.length - 1;
  }

  selectedVariableItem(index: number, operatorValue: string) {
    this.customGroupItemIndex = index;
    if (operatorValue != null) {
      let operatorType = operatorValue == '' ? 'metric' : operatorValue;
      this.invokeValidationRules(operatorType);
    }
  }

  bindCustomGroupOperatorClick(event: Event, operator: string) {
    if (operator == 'NUMERAL') {
      this.isNumeral = true;
      this.isNumeralEvent.emit(true);
      this.showLoaderEvent.emit(false);
    } else {
      this.updateOperatorSelectionCustomGroup(operator);
    }
  }

  private updateOperatorSelectionCustomGroup(operator: string) {
    this.invokeValidationRules(operator);
    this.setCustomGroupRowOrder('', false, '');

    const newEntry = {
      displayString:
        operator == 'NUMERAL' ? operator + ' ' + this.numeralValue : operator,
      oneObject: this.dataObject['CustomGroup'],
      operatorValue: operator,
      type: 'operator',
      rowOrder: this.customGroupRowOrder,
      variableCode: '',
      responseCode: operator == 'NUMERAL' ? this.numeralValue : '',
      headerText: operator,
      notFound: false
    };
    if (this.customGroupItemIndex == -1) {
      this.customGroupSelectionsObj.push(newEntry);
      this.customGroupItemIndex = this.customGroupSelectionsObj.length - 1;
    } else {
      this.customGroupItemIndex = this.customGroupItemIndex + 1;
      this.customGroupSelectionsObj.splice(
        this.customGroupItemIndex,
        0,
        newEntry
      );
    }
    // Re-run with the token now in the list: invokeValidationRules resets the disabled
    // list, re-applies sequential rules for this operator, then re-runs conflict checks
    // based on the correct post-insertion depth/group state.
    this.invokeValidationRules(operator);
    this.cdRef.detectChanges();
  }

  invokeValidationRules(latestSelection: string): void {
    const newValue = latestSelection;
    //$('#DummyForSelectionWatching').attr('latestSelection');

    for (const rule of customGroupsvalidationRules) {
      if (
        rule.latestSelection.toLowerCase() === latestSelection?.toLowerCase()
      ) {
        //const enabledItems = rule.itemsToBeEnabled;
        const disabledItems = rule.itemsToBeDisabled;

        // this.updateButtonState(enabledItems, false);
        this.updateButtonState(disabledItems, true);
      }
    }
  }

  updateButtonState(items: string[], isDisabled: boolean): void {
    this.disabledCustomGroupOperatorList = [];
    for (const item of items) {
      const buttonClass = this.buttonCssClassMap[item];
      this.disabledCustomGroupOperatorList.push(buttonClass);
    }
    this.checkOperatorTypeConflicts();
  }

  /**
   * Enforces the two cross-group operator-type rules:
   *
   * Rule 1 – Within any single parenthesis group, logical (AND/OR/NOT) and
   *           arithmetic (+/-/* //) operators cannot be mixed.
   *           e.g.  (NPS 1 + Aware 2 AND NPS 6)  →  invalid
   *
   * Rule 2 – If the top-level (depth-0) connector is logical, every inner
   *           group must also use only logical operators.
   *           e.g.  (A AND B) AND (C + D)  →  invalid
   *           but   (A AND B) - (C + D)    →  valid
   *
   * Rule 3 – At most 2 parenthesis groups are allowed in any formula.
   *           When 2 groups already exist at depth 1, the '(' button is disabled.
   *           e.g.  (A AND B) - (C AND D)       →  valid (2 groups)
   *                 (A AND B) - (C AND D) - ...  →  invalid (3rd group blocked)
   */
  checkOperatorTypeConflicts(): void {
    const logicalOps   = ['NOT', 'AND', 'OR'];
    const arithmeticOps = ['+', '-', '*', '/', 'NUMERAL'];
    const thresholdOps  = ['*', '/'];

    const groupMap      = this.getGroupOperatorMap(this.customGroupSelectionsObj);
    const currentGroupId = this.getCurrentInsertionGroupId();
    const currentGroup  = groupMap.get(currentGroupId);
    const opsInCurrent  = currentGroup?.operators ?? new Set<string>();
    const currentDepth  = currentGroup?.depth ?? 0;
    const topLevelOps   = groupMap.get(0)?.operators ?? new Set<string>();

    // Threshold button: enabled only when * or / appears anywhere in the formula
    this.isThresholdEnabled = Array.from(groupMap.values()).some(
      g => thresholdOps.some(op => g.operators.has(op))
    );

    const disableButtons = (ops: string[]) => {
      ops.forEach(op => {
        const btn = this.buttonCssClassMap[op];
        if (btn && !this.disabledCustomGroupOperatorList.includes(btn))
          this.disabledCustomGroupOperatorList.push(btn);
      });
    };

    // Rule 1: no mixing within the current group
    if (logicalOps.some(op => opsInCurrent.has(op)))   disableButtons(arithmeticOps);
    if (arithmeticOps.some(op => opsInCurrent.has(op))) disableButtons(logicalOps);

    // Rule 2a: top level has logical  →  inner groups must not use arithmetic
    if (logicalOps.some(op => topLevelOps.has(op)) && currentDepth > 0)
      disableButtons(arithmeticOps);

    // Rule 2b: any inner group already has arithmetic  →  top level must not use logical
    //   e.g.  (A * B) OR (C AND D)  →  the OR should be disabled once (A * B) is built
    const innerGroupHasArithmetic = Array.from(groupMap.values()).some(
      g => g.depth > 0 && arithmeticOps.some(op => g.operators.has(op))
    );
    if (innerGroupHasArithmetic && currentDepth === 0)
      disableButtons(logicalOps);

    // Rules 3 & 4: evaluated only when at the top level (depth 0)
    if (currentDepth === 0) {
      const topLevelGroups = Array.from(groupMap.values()).filter(g => g.depth === 1);

      // Rule 3: At most 2 parenthesis groups are allowed.
      if (topLevelGroups.length >= 2) disableButtons(['(']);

      // Rule 4: All metrics must be inside groups — never allowed at the top level.
      disableButtons(['METRIC']);
    }
  }

  /**
   * Builds a map of groupId → { depth, operators } for every parenthesis group
   * in the token list. Group 0 is the implicit top-level scope (depth 0).
   */
  private getGroupOperatorMap(
    tokens: { type: string; operatorValue: string }[]
  ): Map<number, { depth: number; operators: Set<string> }> {
    const map = new Map<number, { depth: number; operators: Set<string> }>();
    const stack: number[] = [0];
    let counter = 0;
    let depth   = 0;
    map.set(0, { depth: 0, operators: new Set() });

    for (const token of tokens) {
      if (token.type === 'operator') {
        if (token.operatorValue === '(') {
          depth++;
          counter++;
          map.set(counter, { depth, operators: new Set() });
          stack.push(counter);
        } else if (token.operatorValue === ')') {
          stack.pop();
          depth--;
        } else {
          map.get(stack[stack.length - 1])?.operators.add(token.operatorValue);
        }
      }
    }
    return map;
  }

  /**
   * Returns the groupId of the group where the next token will be inserted,
   * determined by replaying the group stack up to customGroupItemIndex.
   */
  private getCurrentInsertionGroupId(): number {
    const upTo = this.customGroupItemIndex === -1
      ? this.customGroupSelectionsObj.length - 1
      : this.customGroupItemIndex;
    const stack: number[] = [0];
    let counter = 0;

    for (let i = 0; i <= upTo && i < this.customGroupSelectionsObj.length; i++) {
      const token = this.customGroupSelectionsObj[i];
      if (token.type === 'operator') {
        if (token.operatorValue === '(') { counter++; stack.push(counter); }
        else if (token.operatorValue === ')') stack.pop();
      }
    }
    return stack[stack.length - 1] ?? 0;
  }

  onThresholdClick(): void {
    // TODO: Implement threshold logic similar to Alert Module
    // Add your threshold implementation here
  }

  private setCustomGroupRowOrder(
    headerText: string,
    ismultipunch: boolean,
    currentVariableCode: string,
    CustomGroupRowOrder?: number
  ) {
    var filteredObj: any = [];

    //if (headerText != null && headerText != '' && ismultipunch) {
    filteredObj = _.filter(
      this.customGroupSelectionsObj,
      (data) =>
        data.headerText == headerText && data.rowOrder == CustomGroupRowOrder
    );
    // } else {
    //   // //other than multipunch will have single value in variableCode
    //   // filteredObj = _.filter(this.customGroupSelectionsObj, (data) =>
    //   //   data.variableCode.includes(currentVariableCode) && data.ro
    //   // );
    //   filteredObj = _.filter(
    //     this.customGroupSelectionsObj,
    //     (data) =>
    //       data.variableCode.includes(currentVariableCode) &&
    //       data.rowOrder == CustomGroupRowOrder
    //   );
    // }

    // // order of newly added row
    // var lastRowOrder =
    //   this.customGroupSelectionsObj.length > 0
    //     ? this.customGroupSelectionsObj[
    //       this.customGroupSelectionsObj.length - 1
    //     ].rowOrder
    //     : this.customGroupRowOrder;

    // Get the maximum rowOrder value from customGroupSelectionsObj
    const maxRowOrder =
      _.maxBy(this.customGroupSelectionsObj, 'rowOrder')?.rowOrder ||
      this.customGroupRowOrder;

    var lastRowOrder = maxRowOrder;

    lastRowOrder = lastRowOrder == undefined ? 0 : lastRowOrder;
    //if this object already exists then take the existing customGroup order if not assign based on maximum value
    this.customGroupRowOrder =
      filteredObj.length > 0 ? filteredObj[0].rowOrder : lastRowOrder + 1;
  }


  clearSelection(seletion: string) {
    if (seletion == 'CustomCalculation') {
      this.listCustomCalculationItemsList = [];
      this.clearCustomCalculationSelection();
    }
    if (seletion == 'CustomGroup') {
      //this.dataObject.CustomGroup = [];
      this.listCustomGroupItemsList = [];
      this.clearCustomGroupSelection();
      //this.getLimitedDataPreview();
    }

  }

  customGroupHtml: string = '';
  customGroupQuery: string = '';
  clearCustomGroupSelection() {
    this.customGroupHtml = '';
    this.customGroupQuery = '';
    this.customGroupRowOrder = 1;
    this.customGroupSelectionsObj = [];
    this.dataObject['CustomGroup'] = [];
    this.listCustomGroupItemsList = [];
    this.disabledCustomGroupOperatorList = [];
    let event: Event = new Event('');
    this.customGroupItemIndex = -1;
    if (this.metrics.length > 0 && this.isCustomMetricPercentage) {
      this.metrics.forEach((m: any) => {
        m.isSelected = false;
      });
    }
    this.bindCustomGroupOperatorClick(event, '(');
  }
  customCalculationHtml: string = '';
  customCalculationQuery: string = '';
  customCalculationRowOrder: number = 1;
  customCalculationSelectionsObj: {
    displayString: string;
    oneObject: any;
    operatorValue: string;
    type: string;
    rowOrder?: number;
    variableCode: string;
    responseCode: string;
    headerText: string;
  }[] = [];
  customCalculationItemIndex: number = -1;
  disabledCustomCalculationOperatorList: string[] = [];

  clearCustomCalculationSelection() {
    this.customCalculationHtml = '';
    this.customCalculationQuery = '';
    this.customCalculationRowOrder = 1;
    this.customCalculationSelectionsObj = [];
    this.dataObject['CustomCalculation'] = [];
    this.listCustomCalculationItemsList = [];
    this.disabledCustomCalculationOperatorList = [];
    let event: Event = new Event('');
    this.customCalculationItemIndex = -1;
    if (this.metrics.length > 0 && this.isCustomMeanMetric) {
      this.metrics.forEach((m: any) => {
        m.isSelected = false;
      });
    }
    this.bindCustomCalculationOperatorClick(event, '(');
  }

  handleNumeralPopUP(eventData: { isClose: boolean }): void {
    this.isNumeral = eventData?.isClose;
  }
  addNumeral(event: { numeralValue: Number }) {
    if (event.numeralValue.toString() != '') {
      this.numeralValue = event.numeralValue.toString();
      if (this.isCustomMeanMetric) {
        this.updateOperatorSelectionCustomCalc('NUMERAL');
      }
      if (this.isCustomMetricPercentage) {
        this.updateOperatorSelectionCustomGroup('NUMERAL');
      }
    }
  }

  isNumeral: boolean = false;
  numeralValue: string = '';
  bindCustomCalculationOperatorClick(event: Event, operator: string) {
    if (operator == 'NUMERAL') {
      this.isNumeral = true;
      this.isNumeralEvent.emit(true);
      this.showLoaderEvent.emit(false);
    } else {
      this.updateOperatorSelectionCustomCalc(operator);
    }
    this.customGroupSelectionsObj.push({
      displayString: operator,
      oneObject: this.dataObject['CustomGroup'],
      operatorValue: operator,
      type: 'operator',
      rowOrder: this.customGroupRowOrder,
      variableCode: '',
      responseCode: '',
      headerText: operator,
      notFound: false
    });
  }

  private updateOperatorSelectionCustomCalc(operator: string) {
    this.invokeValidationRulesCustomCalc(operator);
    this.setCustomCalculationRowOrder('', false, '');
    const newEntry = {
      displayString:
        operator == 'NUMERAL' ? operator + ' ' + this.numeralValue : operator,
      oneObject: this.dataObject['CustomCalculation'],
      operatorValue: operator,
      type: 'operator',
      rowOrder: this.customCalculationRowOrder,
      variableCode: "",
      responseCode: operator == 'NUMERAL' ? this.numeralValue : '',
      headerText: operator,
    };

    if (this.customCalculationItemIndex == -1) {
      this.customCalculationSelectionsObj.push(newEntry);
      this.customCalculationItemIndex =
        this.customCalculationSelectionsObj.length - 1;
    } else {
      this.customCalculationItemIndex = this.customCalculationItemIndex + 1;
      this.customCalculationSelectionsObj.splice(
        this.customCalculationItemIndex,
        0,
        newEntry
      );
    }

    this.setCustomCalculationRowOrder(
      '',
      false,
      '',
      this.customCalculationRowOrder
    );
  }

  private setCustomCalculationRowOrder(
    headerText: string,
    ismultipunch: boolean,
    currentVariableCode: string,
    CustomCalculationRowOrder?: number
  ) {
    var filteredObj: any = [];

    //if (headerText != null && headerText != '' && ismultipunch) {
    filteredObj = _.filter(
      this.customCalculationSelectionsObj,
      (data) =>
        data.headerText == headerText &&
        data.rowOrder == CustomCalculationRowOrder
    );
    // } else {
    //   // //other than multipunch will have single value in variableCode
    //   // filteredObj = _.filter(this.customGroupSelectionsObj, (data) =>
    //   //   data.variableCode.includes(currentVariableCode) && data.ro
    //   // );
    //   filteredObj = _.filter(
    //     this.customGroupSelectionsObj,
    //     (data) =>
    //       data.variableCode.includes(currentVariableCode) &&
    //       data.rowOrder == CustomGroupRowOrder
    //   );
    // }

    // // order of newly added row
    // var lastRowOrder =
    //   this.customGroupSelectionsObj.length > 0
    //     ? this.customGroupSelectionsObj[
    //       this.customGroupSelectionsObj.length - 1
    //     ].rowOrder
    //     : this.customGroupRowOrder;

    // Get the maximum rowOrder value from customGroupSelectionsObj
    const maxRowOrder =
      _.maxBy(this.customCalculationSelectionsObj, 'rowOrder')?.rowOrder ||
      this.customCalculationRowOrder;

    var lastRowOrder = maxRowOrder;

    lastRowOrder = lastRowOrder == undefined ? 0 : lastRowOrder;
    //if this object already exists then take the existing customGroup order if not assign based on maximum value
    this.customCalculationRowOrder =
      filteredObj.length > 0 ? filteredObj[0].rowOrder : lastRowOrder + 1;
  }


  invokeValidationRulesCustomCalc(latestSelection: string, firsttime: number = 0): void {
    const newValue = latestSelection;
    //$('#DummyForSelectionWatching').attr('latestSelection');

    for (const rule of customCalculationvalidationRules) {
      if (
        rule.latestSelection.toLowerCase() === latestSelection?.toLowerCase()
      ) {
        //const enabledItems = rule.itemsToBeEnabled;
        let disabledItems = rule.itemsToBeDisabled;
        if (firsttime == 1)
          disabledItems.push("NUMERAL")

        // this.updateButtonState(enabledItems, false);
        this.updateButtonStateCustomCalc(disabledItems, true);
      }
    }
  }

  updateButtonStateCustomCalc(items: string[], isDisabled: boolean): void {
    this.disabledCustomCalculationOperatorList = [];

    for (const item of items) {
      const buttonClass = this.buttonCssClassMap[item];

      this.disabledCustomCalculationOperatorList.push(buttonClass);
      // if (item.toLowerCase() === 'metric') {
      //   this.renderer.setAttribute(
      //     document.querySelector('#' + buttonClass),
      //     'isdisabled',
      //     attr
      //   );
      // } else {
      //   this.renderer.setAttribute(
      //     document.querySelector('#' + buttonClass),
      //     'isdisabled',
      //     attr
      //   );
      // }
    }
  }

  generateGroupObjects(
    parent: string,
    child: string,
    responseCode: string,
    currentVariableCode: string,
    headerText: string,
    ismultipunch: boolean,
    customGroupRowOrder?: number
  ) {
    if (this.isCustomMeanMetric) {
      this.generateCustomCalculationObjects(parent, child, responseCode, currentVariableCode, headerText, ismultipunch, customGroupRowOrder);
    }
    if (this.isCustomMetricPercentage) {
      this.generateCustomGroupObjects(parent, child, responseCode, currentVariableCode, headerText, ismultipunch, customGroupRowOrder);
    }
  }

  removeGroupObjects(parent: string,
    child: string,
    responseCode: string,
    currentVariableCode: string,
    headerText: string,
    ismultipunch: boolean,
    customGroupRowOrder?: number){
      if (this.isCustomMeanMetric) {
        this.metrics.forEach((m: any) => {
          if (m.option === child) {
            m.isSelected = false;
          }
        });
        this.listCustomCalculationItemsList = this.listCustomCalculationItemsList.filter(
          (r: any) => r.Level1 !== child
        );
        this.customCalculationSelectionsObj = this.customCalculationSelectionsObj.filter(
          (r) => r.displayString !== child
        );
      }
      if (this.isCustomMetricPercentage) {
        this.metrics.forEach((m: any) => {
          if (m.option === child) {
            m.isSelected = false;
          }
        });
        this.listCustomGroupItemsList = this.listCustomGroupItemsList.filter(
          (r) => r.Level1 !== child
        );
        this.customGroupSelectionsObj = this.customGroupSelectionsObj.filter(
          (r) => r.displayString !== child
        );
      }
  }

  generateCustomGroupObjects(
    parent: string,
    child: string,
    responseCode: string,
    currentVariableCode: string,
    headerText: string,
    ismultipunch: boolean,
    customGroupRowOrder?: number
  ) {
    // Guard: if the METRIC button is currently disabled, ignore this click.
    const metricBtnId = this.buttonCssClassMap['METRIC'];
    if (metricBtnId && this.disabledCustomGroupOperatorList.includes(metricBtnId)) return;

    //custom group row order =0 by default if it is added newly...if it is zero ,assign newly generated row order\
    this.setCustomGroupRowOrder(child, false, '', customGroupRowOrder);
    customGroupRowOrder =
      customGroupRowOrder == 0 ? this.customGroupRowOrder : customGroupRowOrder;
    this.invokeValidationRules('metric');
    const rowOrderIndex = this.customGroupSelectionsObj.findIndex(
      (entry) => entry.rowOrder === customGroupRowOrder
    );

    //each object of customgroup selection has seperate row order
    let isSelected = true;
    this.metrics.forEach((m: any) => {
      if (m.option === child) {
        m.isSelected = true;
        isSelected = true;
      }
    });
    let displayString = child;
    if (isSelected) {
      this.listCustomGroupItemsList.push({
        customGroupRowOrder: customGroupRowOrder,
        Level0: parent,
        Level1: child,
        tooltip: '',
        has_nextLevel: false,
        sortId: 0,
        is_Derived: '',
        is_calc_type: '',
        data_variable_code: currentVariableCode,
        data_response_code: responseCode,
        data_sort_id: '',
        data_is_multi_punch: '',
        data_date: '',
        data_year_code: '',
        is_dimension: false,
        is_custmGrpPresent: true,
        is_custmCalcPresent: false,
        kibanaFilterScript: '',
        customGroupId: '',
        customCalculationId: '',
        dataYearCode: '',
        isSelectAllMetrics: false,
        isSelectAllMetricsCount: 0,
        is_entrypoint: false
      });
      const newEntry = {
        displayString: displayString,
        oneObject: {},
        operatorValue: '',
        type: 'metric',
        rowOrder: customGroupRowOrder,
        variableCode:currentVariableCode,
        responseCode: responseCode,
        headerText: headerText,
        isMultipunch: false,
        notFound: false
      };

      // if its entry os not there insert as a new row
      if (rowOrderIndex == -1) {
        if (this.customGroupItemIndex == -1) {
          this.customGroupSelectionsObj.push(newEntry);
          this.customGroupItemIndex = this.customGroupSelectionsObj.length - 1;
        } else {
          this.customGroupItemIndex = this.customGroupItemIndex + 1;
          this.customGroupSelectionsObj.splice(
            this.customGroupItemIndex,
            0,
            newEntry
          );
        }
      } //else overwrite exisinting row
      else {
        this.customGroupSelectionsObj[rowOrderIndex] = newEntry;
        // if(rowOrderIndex!=this.customGroupItemIndex){
        //  this.customGroupItemIndex = this.customGroupSelectionsObj.length - 1;
        this.customGroupItemIndex = rowOrderIndex;
        //}
      }
    }
    else {
      this.listCustomGroupItemsList = this.listCustomGroupItemsList.filter(
        (r) => r.Level1 !== child
      );
      this.customGroupSelectionsObj = this.customGroupSelectionsObj.filter(
        (r) => r.displayString !== child
      );
    }
    // Re-run with token now in the list: full reset + sequential + conflict checks.
    this.invokeValidationRules('metric');
  }

  generateCustomCalculationObjects(
    parent: string,
    child: string,
    responseCode: string,
    currentVariableCode: string,
    headerText: string,
    ismultipunch: boolean,
    customCalculationRowOrder?: number
  ) {
    //custom group row order =0 by default if it is added newly...if it is zero ,assign newly generated row order
    this.setCustomCalculationRowOrder(child, false, '', customCalculationRowOrder);
    customCalculationRowOrder =
      customCalculationRowOrder == 0
        ? this.customCalculationRowOrder
        : customCalculationRowOrder;
    this.invokeValidationRulesCustomCalc('metric');
    //each object of customgroup selection has seperate row order
    const rowOrderIndex = this.customCalculationSelectionsObj.findIndex(
      (entry) => entry.rowOrder === customCalculationRowOrder
    );



    //update droped custom group metrics...unique id for metric which is added newly with default custom group row order
    // this.listCustomCalculationItemsList.map((s: any) => {
    //   if (s.Level1 === parent && s.customCalculationRowOrder == 0) {
    //     s.customCalculationRowOrder = customCalculationRowOrder;
    //     return true; // Keep the element in the filtered array
    //   }
    //   return false; // Exclude the element from the filtered array
    // });




    //generate displayString
    var displayString = child
    let isSelected = true;
    this.metrics.forEach((m: any) => {
      if (m.option === child) {
        m.isSelected = true;
        isSelected = true;
      }
    });

    if (isSelected) {
      this.listCustomCalculationItemsList.push({
        customGroupRowOrder: customCalculationRowOrder,
        Level0: parent,
        Level1: child,
        tooltip: '',
        has_nextLevel: false,
        sortId: 0,
        is_Derived: '',
        is_calc_type: '',
        data_variable_code: currentVariableCode,
        data_response_code: responseCode,
        data_sort_id: '',
        data_is_multi_punch: '',
        data_date: '',
        data_year_code: '',
        is_dimension: false,
        is_custmGrpPresent: true,
        is_custmCalcPresent: false,
        kibanaFilterScript: '',
        customGroupId: '',
        customCalculationId: '',
        dataYearCode: '',
        isSelectAllMetrics: false,
        isSelectAllMetricsCount: 0,
        is_entrypoint: false
      });
      const newEntry = {
        displayString: displayString,
        oneObject: {},
        operatorValue: '',
        type: 'metric',
        rowOrder: customCalculationRowOrder,
        variableCode: "",
        responseCode: "",
        headerText: headerText,
        isMultipunch: false,
        notFound: false
      };

      //if its entry os not there insert as a new row
      if (rowOrderIndex == -1) {
        if (this.customCalculationItemIndex == -1) {
          this.customCalculationSelectionsObj.push(newEntry);
          this.customCalculationItemIndex =
            this.customCalculationSelectionsObj.length - 1;
        } else {
          this.customCalculationItemIndex = this.customCalculationItemIndex + 1;
          this.customCalculationSelectionsObj.splice(
            this.customCalculationItemIndex,
            0,
            newEntry
          );
        }
      } //else overwrite exisinting row
      else {
        this.customCalculationSelectionsObj[rowOrderIndex] = newEntry;
        this.customCalculationItemIndex =rowOrderIndex;
          // this.customCalculationSelectionsObj.length - 1;
      }
    }
    else {
      this.listCustomCalculationItemsList = this.listCustomCalculationItemsList.filter(
        (r: any) => r.Level1 !== child
      );
      this.customCalculationSelectionsObj = this.customCalculationSelectionsObj.filter(
        (r) => r.displayString !== child
      );
    }
  }

  // generateCustomGroupObjects(
  //   parent: string,
  //   child: string,
  //   responseCode: string,
  //   currentVariableCode: string,
  //   headerText: string,
  //   ismultipunch: boolean,
  //   customGroupRowOrder?: number
  // ) {
  //   //custom group row order =0 by default if it is added newly...if it is zero ,assign newly generated row order\
  //   this.setCustomGroupRowOrder(child, false, '', customGroupRowOrder);
  //   customGroupRowOrder =
  //     customGroupRowOrder == 0 ? this.customGroupRowOrder : customGroupRowOrder;
  //   this.invokeValidationRules('metric');
  //   const rowOrderIndex = this.customGroupSelectionsObj.findIndex(
  //     (entry) => entry.rowOrder === customGroupRowOrder
  //   );

  //   //each object of customgroup selection has seperate row order
  //   let isSelected = true;
  //   this.metrics.forEach((m: any) => {
  //     if (m.option === child) {
  //       m.isSelected = !m.isSelected;
  //       isSelected = m.isSelected;
  //     }
  //   });
  //   let displayString = child;
  //   if (isSelected) {
  //     this.listCustomGroupItemsList.push({
  //       customGroupRowOrder: customGroupRowOrder,
  //       Level0: parent,
  //       Level1: child,
  //       tooltip: '',
  //       has_nextLevel: false,
  //       sortId: 0,
  //       is_Derived: '',
  //       is_calc_type: '',
  //       data_variable_code: currentVariableCode,
  //       data_response_code: responseCode,
  //       data_sort_id: '',
  //       data_is_multi_punch: '',
  //       data_date: '',
  //       data_year_code: '',
  //       is_dimension: false,
  //       is_custmGrpPresent: true,
  //       is_custmCalcPresent: false,
  //       kibanaFilterScript: '',
  //       customGroupId: '',
  //       customCalculationId: '',
  //       dataYearCode: '',
  //       isSelectAllMetrics: false,
  //       isSelectAllMetricsCount: 0,
  //       is_entrypoint: false
  //     });
  //     const newEntry = {
  //       displayString: displayString,
  //       oneObject: {},
  //       operatorValue: '',
  //       type: 'metric',
  //       rowOrder: customGroupRowOrder,
  //       variableCode:currentVariableCode,
  //       responseCode: responseCode,
  //       headerText: headerText,
  //       isMultipunch: false,
  //       notFound: false
  //     };

  //     // if its entry os not there insert as a new row
  //     if (rowOrderIndex == -1) {
  //       if (this.customGroupItemIndex == -1) {
  //         this.customGroupSelectionsObj.push(newEntry);
  //         this.customGroupItemIndex = this.customGroupSelectionsObj.length - 1;
  //       } else {
  //         this.customGroupItemIndex = this.customGroupItemIndex + 1;
  //         this.customGroupSelectionsObj.splice(
  //           this.customGroupItemIndex,
  //           0,
  //           newEntry
  //         );
  //       }
  //     } //else overwrite exisinting row
  //     else {
  //       this.customGroupSelectionsObj[rowOrderIndex] = newEntry;
  //       // if(rowOrderIndex!=this.customGroupItemIndex){
  //       //  this.customGroupItemIndex = this.customGroupSelectionsObj.length - 1;
  //       this.customGroupItemIndex = rowOrderIndex;
  //       //}
  //     }
  //   }
  //   else {
  //     this.listCustomGroupItemsList = this.listCustomGroupItemsList.filter(
  //       (r) => r.Level1 !== child
  //     );
  //     this.customGroupSelectionsObj = this.customGroupSelectionsObj.filter(
  //       (r) => r.displayString !== child
  //     );
  //   }


  // }

  //custom calculation for mean metric
  // generateCustomCalculationObjects(
  //   parent: string,
  //   child: string,
  //   responseCode: string,
  //   currentVariableCode: string,
  //   headerText: string,
  //   ismultipunch: boolean,
  //   customCalculationRowOrder?: number
  // ) {
  //   //custom group row order =0 by default if it is added newly...if it is zero ,assign newly generated row order
  //   this.setCustomCalculationRowOrder(child, false, '', customCalculationRowOrder);
  //   customCalculationRowOrder =
  //     customCalculationRowOrder == 0
  //       ? this.customCalculationRowOrder
  //       : customCalculationRowOrder;
  //   this.invokeValidationRulesCustomCalc('metric');
  //   //each object of customgroup selection has seperate row order
  //   const rowOrderIndex = this.customCalculationSelectionsObj.findIndex(
  //     (entry) => entry.rowOrder === customCalculationRowOrder
  //   );



  //   //update droped custom group metrics...unique id for metric which is added newly with default custom group row order
  //   // this.listCustomCalculationItemsList.map((s: any) => {
  //   //   if (s.Level1 === parent && s.customCalculationRowOrder == 0) {
  //   //     s.customCalculationRowOrder = customCalculationRowOrder;
  //   //     return true; // Keep the element in the filtered array
  //   //   }
  //   //   return false; // Exclude the element from the filtered array
  //   // });




  //   //generate displayString
  //   var displayString = child
  //   let isSelected = true;
  //   this.metrics.forEach((m: any) => {
  //     if (m.option === child) {
  //       m.isSelected = !m.isSelected;
  //       isSelected = m.isSelected;
  //     }
  //   });

  //   if (isSelected) {
  //     this.listCustomCalculationItemsList.push({
  //       customGroupRowOrder: customCalculationRowOrder,
  //       Level0: parent,
  //       Level1: child,
  //       tooltip: '',
  //       has_nextLevel: false,
  //       sortId: 0,
  //       is_Derived: '',
  //       is_calc_type: '',
  //       data_variable_code: currentVariableCode,
  //       data_response_code: responseCode,
  //       data_sort_id: '',
  //       data_is_multi_punch: '',
  //       data_date: '',
  //       data_year_code: '',
  //       is_dimension: false,
  //       is_custmGrpPresent: true,
  //       is_custmCalcPresent: false,
  //       kibanaFilterScript: '',
  //       customGroupId: '',
  //       customCalculationId: '',
  //       dataYearCode: '',
  //       isSelectAllMetrics: false,
  //       isSelectAllMetricsCount: 0,
  //       is_entrypoint: false
  //     });
  //     const newEntry = {
  //       displayString: displayString,
  //       oneObject: {},
  //       operatorValue: '',
  //       type: 'metric',
  //       rowOrder: customCalculationRowOrder,
  //       variableCode: "",
  //       responseCode: "",
  //       headerText: headerText,
  //       isMultipunch: false,
  //       notFound: false
  //     };

  //     //if its entry os not there insert as a new row
  //     if (rowOrderIndex == -1) {
  //       if (this.customCalculationItemIndex == -1) {
  //         this.customCalculationSelectionsObj.push(newEntry);
  //         this.customCalculationItemIndex =
  //           this.customCalculationSelectionsObj.length - 1;
  //       } else {
  //         this.customCalculationItemIndex = this.customCalculationItemIndex + 1;
  //         this.customCalculationSelectionsObj.splice(
  //           this.customCalculationItemIndex,
  //           0,
  //           newEntry
  //         );
  //       }
  //     } //else overwrite exisinting row
  //     else {
  //       this.customCalculationSelectionsObj[rowOrderIndex] = newEntry;
  //       this.customCalculationItemIndex =rowOrderIndex;
  //         // this.customCalculationSelectionsObj.length - 1;
  //     }
  //   }
  //   else {
  //     this.listCustomCalculationItemsList = this.listCustomCalculationItemsList.filter(
  //       (r: any) => r.Level1 !== child
  //     );
  //     this.customCalculationSelectionsObj = this.customCalculationSelectionsObj.filter(
  //       (r) => r.displayString !== child
  //     );
  //   }
  // }



  createCustomGroup() {

  }

  clearCustomGroup() {
  }
}
